const lessonData = (state = {}, action) => {
  if (action.type === "SET_LESSON_DATA") {
    if (action.payload === 2) {
      let data = {
        1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "A hospital registration desk",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/martha-dominguez-de-gouveia-nMyM7fxpokE-unsplash.jpg",
              order: 0,
            },
          ],
          layoutNumber: 3,
          navigation: [
            { available_scene: "2", current_scene: "1", text: "Continue" },
          ],
          scene_number: "1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: "Healing or Hallucination?",
          videos: [],
          audio: [],
        },
        2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "3", current_scene: "2", text: "Continue" },
          ],
          scene_number: "2",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Being a chaplain requires tending to the complex dynamics of interpersonal relationships.</p><p>Chaplains often work in multidisciplinary teams, navigating diverse needs and experiences to provide spiritual care, potentially to everyone in an organization. As such, it is crucial that chaplains understand how they fit within a larger ecosystem at work and how to act in their unique roles.</p>`,
          ],
          title: "Interpersonal competencies",
          videos: [],
          audio: [],
        },
        3: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "4", current_scene: "3", text: "Continue" },
          ],
          scene_number: "3",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Chaplains draw upon their training to decide how to act when faced with challenging interpersonal situations: assessing the situation, providing care to all who are impacted, and attending to any residual conflict.</p><p>In this lesson, you will encounter a situation where you as a chaplain must provide care to your patient, but you must also address and care for your relationship with the medical team to address dynamics that could cause your patient harm. How will you navigate all of these different relationships and what tools, skills, and knowledge will you draw upon to do so?</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        4: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "5", current_scene: "4", text: "Continue" },
          ],
          scene_number: "4",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>By the end of this lesson, you will be able to:</p>
            <ul>
            <li>analyze the varying interpersonal dilemmas provoked among the various stakeholders this case study, and their relational impact</li>
            <li>engage the specific expertise and competencies you bring to this multidisciplinary team as a chaplain (critical use of knowledge in religious, psychological, and cultural studies).</li>
            <li>propose ways to intervene, based on your expertise and positionality, which indicates attention to the intersectional aspects of self and others’ social identity</li>
            <li>explore the relational impact your differing responses may have on the patient and your colleagues, using the understandings of self and spiritual differentiation</li>
            <li>identify the emotions this situation engenders in you, using breath- and body-centered practices as the chaplain, with respect to the multidisciplinary team and the patient</li>
            </ul>`,
          ],
          title: "What you will learn",
          videos: [],
          audio: [],
        },
        5: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "6", current_scene: "5", text: "Continue" },
          ],
          scene_number: "5",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Angie is a 25-year-old, single African-American woman with advanced Hodgkin’s lymphoma. She has been admitted to a large, public teaching hospital and is waiting for a palliative care bed. She is expected to die during this hospitalization.</p>`,
          ],
          title: "Meet Angie",
          videos: [],
          audio: [],
        },
        6: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              image:
                "https://d38v7trvdc57zc.cloudfront.net/interpersonal/martha-dominguez-de-gouveia-k-NnVZ-z26w-unsplash.jpg",
              alt: "Hospital room with bare walls.",
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "7", current_scene: "6", text: "Continue" },
          ],
          scene_number: "6",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You are the hospital’s chaplain responsible for covering the oncology unit. For more than a week, Angie has been unresponsive. You make a brief visit daily. She receives no other visitors; the walls are bare of cards, and there are no flowers in the room.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        7: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "8", current_scene: "7", text: "Continue" },
          ],
          scene_number: "7",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You know from prior visits that Angie is alienated from her family and distances herself from people she says were “bad influences” before her cancer diagnosis and earlier recovery from addiction. She credits a return to the Pentecostalism of her youth as the reason she has sustained sobriety.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        8: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "8.1", current_scene: "8", text: "Continue" },
          ],
          scene_number: "8",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Angie has rallied, becoming responsive this morning. In learning of this from your morning rounds, you decide to check in with her, and see if she would be open to a visit from you. When you ask her about her experience she says:<blockquote>It was just me and God dancing together up there in the corner. I had on a red dress. The prettiest red dress. I've never wore nothing like it. We danced and danced. You know, people always say, “God is this” or, “God is that.” God isn’t nothing we know about, even if he is a darned good dancer. It’s just, “God is.”</blockquote> <p>She pauses. There are tears in her eyes.</p> <blockquote>Not even, “God is.” Just, “IS.”</blockquote>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        8.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "8.2", current_scene: "8.1", text: "Continue" },
          ],
          scene_number: "8.1",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<p>This definition of spiritual assessment was inspired by Spiritual Assessment and Intervention Model (Spiritual AIM).</p><a href="https://doi.org/10.1017/S1478951513001120" target="_blank">Read more about the Spiritual AIM model.</a> `,
          ],
          text: [
            `<p>As the chaplain, you conduct a spiritual assessment with Angie as you have been invited by Angie into her space of reflection.</p><p>Spiritual assessment involves diagnosing an individual’s primary unmet spiritual need or concern and formulating a plan about how to address that need through a process of particular interventions aimed at healing outcomes.</p>`,
          ],
          title: `Spiritual assessment`,
          videos: [],
          audio: [],
        },
        8.2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "8.3", current_scene: "8.2", text: "Continue" },
          ],
          scene_number: "8.2",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>According to Shields, Kestenbaum, Dunn (2014), spiritual assessment is a diagnostic process that centers the needs and experiences of the patient, utilizing back and forth dialog rather than a set of narrow, prescribed questions.</p><p>There are many forms of spiritual assessments that help serve your care receiver. Some chaplains use spiritual assessment models that are developed formally by practitioners, while others incorporate their own practices (based on their experiences and research) into formalized models.</p>`,
          ],
          title: null,
          videos: [
            {
              data: "https://www.youtube.com/embed/xCPfw4VCugw",
              alt: "Allison Kestenbaum on the Spiritual AIM model.",
            },
          ],
          audio: [],
        },
        8.3: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "8.4", current_scene: "8.3", text: "Continue" },
          ],
          scene_number: "8.3",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Notably, a “spiritual assessment” is not a tool reserved solely for healthcare chaplains; any spiritual care provider may employ this lens to help understand concerns before them, and address them appropriately. Spiritual assessment gives the chaplain language to name, analyze, and understand the care and serves the healthcare chaplain in charting, the process of recording progress of patient's condition into a medical record.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        8.4: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: `<strong>This is a great answer.</strong> Based on what we know about Angie, she may be exhibiting these behaviors in the Meaning and Direction category: Patient employs several metaphors, images, or analogies in conversation; Patient asks questions and demonstrates curiosity (e.g., about illness, the nature of God or religion); Patient feels enticed, yet encumbered by exploring infinite possibilities.`,
              answer: true,
              content_type: 5,
              data: "Meaning and Direction",
              order: 0,
              question_type: null,
              scene_number: "8.4",
              sidebar: false,
            },
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>Based on what you know about Angie, what do you think her primary spiritual need is at this moment?</p>",
              order: 0,
              question_type: 1,
              scene_number: "8.4",
              sidebar: false,
            },
            {
              alt:
                "Based on what we know about Angie, this answer is <strong>probably incorrect</strong>. Angie does not mention anything about 'concern for others and fears burdening them,' nor does she minimize her own needs to prioritize caring for others.",
              answer: true,
              content_type: 5,
              data: "Self-Worth & Belonging to Community",
              order: 1,
              question_type: null,
              scene_number: "8.4",
              sidebar: false,
            },
            {
              alt:
                "While reconcilation seems to be part of Angie's story, in the current moment, this doesn't seem to be her primary spiritual concern. <strong>This answer is incorrect.</strong> She is not presenting as combative, nor does she blame others or discuss broken or strained relationships. ",
              answer: true,
              content_type: 5,
              data: "Reconciliation/to Love and Be Loved",
              order: 2,
              question_type: null,
              scene_number: "8.4",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "8.5", current_scene: "8.4", text: "Continue" },
          ],
          scene_number: "8.4",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>According to the Spiritual AIM model, there are three cores areas of spiritual need that a person may seek, each with its own primary spiritual task. A primary spiritual task can be thought of as a person's greatest need - or what drives them to seek spiritual care in any given moment. A chaplain determines what a patient's primary spiritual need is by observing a care recipient. They then determine a plan of care that best suits the patient's needs.</p><p> Reivew the information below. Based on what you know about Angie, what do you think her area of greatest spiritual need is?</p>
            <section>
            <h4><strong>Meaning and Direction</strong></h4>
            <p>Primary spiritual task: Learn to be in relation to self and therefore others (God)</p>
            <iframe width="100%" height="400" src="https://www.youtube.com/embed/iT8-yqxYXO4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </section><section>
            <h4><strong>Self-Worth & Belonging to Community</strong></h4>
            <p>Primary spiritual task: Learn to love self</p>
            <iframe width="100%" height="400" src="https://www.youtube.com/embed/UCb0auNco3g" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </section>
            <section>
            <h4><strong>Reconciliation/to Love and Be Loved</strong></h4>
            <p>Primary spiritual task: Learn to love others (God)</p>
            <iframe width="100%" height="400" src="https://www.youtube.com/embed/7-jPP4Skb1w" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </section>`,
          ],
          title: `Defining Angie's unmet spiritual need`,
          videos: [],
          audio: [],
        },
        8.5: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>What are the top three interventions that you chose to engage Angie? Why did you choose them?</p>",
              order: 0,
              question_type: 2,
              scene_number: "8.5",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "9", current_scene: "8.5", text: "Continue" },
          ],
          scene_number: "8.5",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You decide that Angie's primary spiritual need is Meaning & Direction based on the Spiritual AIM model. According to this model, a chaplain caring for a patient who is seeking meaning and direction may "feel in a fog or have difficulty following what patient is
            saying." It is important that you are aware that you may have trouble following Angie and actively try to connect with her using some of the recommended interventions.</p><p>Review these interventions and identify the top three interventions you would try to engage Angie, knowing what you know about her needs, her particular context, and your own subjectivity as a chaplain. Jot down your top three interventions on a piece of paper.</p><section><h3><strong>Plan for Embodiment of the Chaplain—“to Be” a Guide</strong></h3><ul><li>Name and reflect back emotions (especially anger) as a source of clarity.</li><li>Gauge what decisions need to be made or questions need to be answered.</li><li>Ask patient how he/she has coped with similar crises and circumstances or made decisions in the past.</li><li>Help patient to name resources to help make decisions, answer questions, or achieve clarity about their heart’s desire.</li><li>Demonstrate support and guidance, as if walking along side patient on a path.</li><li>Honor when patient makes important decision (e.g., regarding treatment, to enroll in hospice, to take an important trip).</li><li>Honor when patient arrives at a new meaning (e.g., deciding upon a legacy project like a video, letter for child).</li><li>Commission the patient for this decision/work/meaning with a blessing or ritual (religious or nonreligious/poetic).</li></ul></section>`,
          ],
          title: `Creating a plan for embodiment`,
          videos: [],
          audio: [],
        },
        9: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "10", current_scene: "9", text: "Continue" },
          ],
          scene_number: "9",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Angie goes on to tell you that while she was unresponsive, she received a blessing and a healing; that even though she will die with the cancer, she has been made whole. You affirm Angie's experience, reflecting the emotions she is sharing with you back to her. Your expression of support builds Angie's trust in you and allows you to step into the role of the spiritual guide: walking alongside her as she seeks meaning and direction.</p><p>You wrap up your visit with Angie and make a note of the encounter in her medical chart.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        10: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "10.1", current_scene: "10", text: "Continue" },
          ],
          scene_number: "10",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>The next morning, you report your conversation with Angie and your subsequent spiritual assessment at interdisciplinary rounds just before the treatment team enters Angie’s room. She can hear what is happening in the hallway.</p><p>The chief oncologist, a middle-aged white man, turns to the team and medical students and says,</p> <blockquote>“And here we have a prime example of drug-induced hallucination. People experience all sorts of things because of the medications we give them to fight cancer. I suggest you don’t give these sorts of things any credibility. Let patients reserve their energy for the fight against the disease.”</blockquote>`,
          ],
          title: null,
          videos: [],
          audio: [
            `https://d38v7trvdc57zc.cloudfront.net/interpersonal/ambience_hospital_foyer_cafe_people_chat_busy_uk.mp3`,
          ],
        },
        10.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            {
              available_scene: "10.2",
              current_scene: "10.1",
              text: "Continue",
            },
          ],
          scene_number: "10.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: null,
          videos: [
            {
              data:
                "https://www.youtube.com/embed/Y0ogrddQqaY?autoplay=1&rel=0",
              alt: "Assessing the different relationships in this scenario.",
            },
          ],
          audio: [],
        },
        10.2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 9,
          navigation: [
            { available_scene: "11", current_scene: "10.1", text: "Continue" },
          ],
          scene_number: "10.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Aware of the complex web of relationships, identities, and status in the hospital system, you must decide whether and how to intervene. 
            It is your duty to tend to the spiritual needs of all who require care, which may not just be Angie, but also include the oncologist or the medical students.</p><p>Consider how these groups might be seeking Reconcilation/to Love or Be Loved. How can you provide caring interventions to all who are present based on what you know?</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        11: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              image: `https://d38v7trvdc57zc.cloudfront.net/interpersonal/irwan-rbDE93-0hHs-unsplash.jpg`,
              alt:
                "A person wearing scrubs, sitting in front of a computer, with their hand on the mouse.",
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "12", current_scene: "11", text: "Continue" },
          ],
          scene_number: "11",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Because you work in a medical setting, you must record the spiritual care you provided to Angie in her medical record, a process called "charting."</p><p>It’s important to remember that the chart is a legal document and that patients can read what has been written in their chart should they request it. Your chart note should be accurate by capturing observations and have what the patient said in quotes. Charting takes practice. It is an art form to be able to capture the most salient points in a way that reports necessary information while also honoring patient confidentiality - excluding any superfluous details. Only information that will help provide integrated multi-disciplinary care should be shared.</p>`,
          ],
          title: "Documenting the experience",
          videos: [],
          audio: [],
        },
        12: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              image:
                "https://d38v7trvdc57zc.cloudfront.net/interpersonal/medical-record-01.png",
              alt: "",
              order: 86,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "13", current_scene: "12", text: "Continue" },
          ],
          scene_number: "12",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [`<p>The medical record contains a chaplain's assessments, interventions, notes on outcomes, and a plan of care to support the patient.</p>`],
          title: "What goes into the medical record?",
          videos: [],
          audio: [],
        },
        13: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "14", current_scene: "13", text: "Continue" },
          ],
          scene_number: "13",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>How do you document a potentially sensitive dynamic with other staff? For the purpose of charting, this is not the place to express your uncomfortable feelings toward the staff members. With these concerns, depending on the severity, you can speak with the person yourself, to their supervisor, or your supervisor. Your goal with charting is to support the patient care of Angie. Therefore, whatever interactions you state about your work with the team members in the chart should be connected for the benefit of Angie’s care. For instance, a chaplain may chart: </p><blockquote>“Chaplain raised up with the oncologist and team the holistic benefits of acknowledging Angie’s process of making meaning of her dreams as a resource in providing care for her. Will continue the conversation as needed to better support her end of life care.”</blockquote>`,
          ],
          title: "Sensitive matters",
          videos: [],
          audio: [],
        },
        14: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              image: `https://d38v7trvdc57zc.cloudfront.net/interpersonal/pexels-jonathan-borba-3279197.jpg`,
              alt: `A person wearing scrubs with their head down in prayer.`,
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "15", current_scene: "14", text: "Continue" },
          ],
          scene_number: "14",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Spiritual care happens within the space of relationships. By developing self-knowledge and using one’s agency to bring about changes, a chaplain can meet a person's spiritual needs, using skills such as active listening, attending to power, emotional attunement, cultural humility, empathic reflection, and conflict resolution.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        15: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "15.1", current_scene: "15", text: "Continue" },
          ],
          scene_number: "15",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<section><h3>Self-reflection is a crucial part of learning to manage interpersonal dynamics as a chaplain.</h3><p> Take a few moments to reflect upon these concluding questions.</p></section>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        15.1: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>What emotions and reactions did you notice arise within you as you experienced this lesson?</p>",
              order: 0,
              question_type: 2,
              scene_number: "16",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "16", current_scene: "15.1", text: "Continue" },
          ],
          scene_number: "15.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: null,
          videos: [
            {
              data: "https://www.youtube.com/embed/9o6jRXJDjuw",
              alt:
                "What emotions and reactions did you notice arise within you as you experienced this lesson?",
            },
          ],
          audio: [],
        },
        16: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>What were the personal values that influenced your approach in meeting the spiritual needs of Angie?</p>",
              order: 0,
              question_type: 2,
              scene_number: "16",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "18", current_scene: "16", text: "Continue" },
          ],
          scene_number: "16",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: null,
          videos: [
            {
              data: "https://www.youtube.com/embed/oO_siPJ8y3Y",
              alt:
                "What were the personal values that influenced your approach in meeting the spiritual needs of Angie?",
            },
          ],
          audio: [],
        },
        18: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>What racial, religious, cultural, class, gender, and sexuality dynamics (aspects of identity) worked for you and against you as you worked through this lesson?</p>",
              order: 0,
              question_type: 2,
              scene_number: "16",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "19", current_scene: "18", text: "Continue" },
          ],
          scene_number: "18",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: null,
          videos: [
            {
              data: "https://www.youtube-nocookie.com/embed/W9U_8MfUtqk",
              alt:
                "What racial, religious, cultural, class, gender, and sexuality dynamics (aspects of identity) worked for you and against you as you worked through this lesson?",
            },
          ],
          audio: [],
        },
        19: {
          checkpoint: false,
          last: true,
          checkpoints: [],
          images: [],
          layoutNumber: 6,
          navigation: [],
          scene_number: "19",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You finished this lesson! Take a moment to download your responses to the questions you answered along the way. You can print them for future review or to show to your instructor if you are using this lesson in a class.</p>`
          ],
          title: "Lesson complete",
          videos: [],
          audio: [],
        },
      };
      return data;
    } else if (action.payload === 3) {
      let data = {
        1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Vassar students",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/0020-19-04-kr-passover-vassar-8644.jpg",
              order: 0,
            },
          ],
          layoutNumber: 3,
          navigation: [
            { available_scene: "2", current_scene: "1", text: "Continue" },
          ],
          scene_number: "1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: "Transforming Chaplaincy at Vassar College",
          videos: [],
          audio: [],
        },
        2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "3", current_scene: "2", text: "Continue" },
          ],
          scene_number: "2",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Chaplains are often tasked with a unique set of challenges in a workplace. Many chaplains work in secular spaces - hospitals, prisons, the military, and on college campuses. While there is a need for chaplaincy in each of these institutions, not everyone in these organizations may understand or value the role of the chaplain.</p><p> Thus, although chaplains serve as religious or spiritual leaders, in order to effectively serve people, they must also learn how to identify, navigate, and impact the <em>teams and institutions</em> they work in.</p>`,
          ],
          title: "Organizational competencies",
          videos: [],
          audio: [],
        },
        3: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "4", current_scene: "3", text: "Continue" },
          ],
          scene_number: "3",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>There are many ways to understand the priorities and culture of an institution or team. Some understanding comes from experience: working within an organization for many years. In other cases, a new chaplain’s fresh perspective on a workplace’s dynamics may bring to light unspoken assumptions and biases about an organization.</p><p> Understanding the culture and priorities of a workplace is a powerful first step, enabling chaplains to make changes to improve their chaplaincy: expanding their reach, deepening their connections, and transforming their own practice.</p>`,
          ],
          title: "How does a chaplain learn these skills?",
          videos: [],
          audio: [],
        },
        4: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "5", current_scene: "4", text: "Continue" },
          ],
          scene_number: "4",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>In this lesson, we will explore one approach to building “organizational competency” in your chaplaincy called “design thinking.” Design thinking is a methodology which can be used to conduct a needs assessment of your institution: identifying problems and building solutions based on research, prototyping, and evaluation. </p><p>Design thinking prioritizes the needs of users in their actual contexts, making it a good approach for those of us who are interested in creating meaningful programs based on the needs of the populations we serve. </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        5: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "6", current_scene: "5", text: "Continue" },
          ],
          scene_number: "5",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>We’ll explore the design thinking process by examining how one institution, Vassar College, embraced this methodology to transform religious and spiritual life on their campus.</p><p> When you complete this lesson, you should be able to: <ul><li>understand the process of design thinking;</li><li>consider how you might apply this methodology to your own institution.</li></ul></p><p> While each institution is unique and your workplace may be vastly different from (or fairly similar to) Vassar, consider how the underlying strategies of design thinking could help you to understand, brainstorm, implement, and evaluate change within your own contexts.</p>`,
          ],
          title: "What will you learn?",
          videos: [],
          audio: [],
        },
        6: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/0024_13_02_BL_076.jpg",
              alt: "A group of Vassar students with Rev. Speers",
              order: 2,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "7", current_scene: "6", text: "Continue" },
          ],
          scene_number: "6",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>Further Reading</h3>
            <p><a href="http://religion.ssrc.org/reforum/Speers.pdf" target="_blank" rel="noopener noreferrer">Secularity, Spirituality, and Liberal Arts Education</a> by Sam Speers</p>`,
          ],
          text: [
            `<p>Vassar College is a small, private, residential, and highly selective liberal arts college located in upstate New York with a population of approximately 2,400 undergraduate students.</p> <p>Although many Vassar students would consider themselves to be religious or spiritual, much like many other colleges and universities, Vassar is finding a growing number of students do not have any formal religious affiliation. In 2018, of students who responded to the college’s annual interest form, 10% were Protestant, 9% Jewish, 8% Catholic, and under 2% Muslim, Hindu, and Buddhist. Approximately 45% declared themselves to be atheist or agnostic. In the previous ten years, the percentage of agnostic or atheist students has gone up by about 10%.</p><p>Since the early 2000s, Vassar regularly made the Princeton Review’s top ten list of schools where students were “most likely to ignore God on a regular basis.”</p>`,
          ],
          title: "About Vassar College",
          videos: [],
        },
        7: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Vassar College Chapel exterior",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Chapel_06_TT_22-standard.jpg",
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "8", current_scene: "7", text: "Continue" },
          ],
          scene_number: "7",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<div>
            <section>
            <h3>Vassar has reimagined and reorganized chaplaincy multiple times in its history.</h3></section>
            <ul>
            <li>In 1926 Vassar transformed the Christian Association (part of the ecumenical YMCA/Student Christian Movement) into the Vassar Community Church. Dr. Edwin Aubrey was instrumental in this process. The <a href="https://newspaperarchives.vassar.edu/?a=d&d=vcchro19561208-01.2.14&srpos=3&e=-------en-20--1--txt-txIN-chaplain+Aubrey-------" target="_blank">report from 1926</a> said the chaplain “plans each daily service” and that “services are interdenominational, and are led by faculty, students and guest speakers representing all faiths and creeds.” </li>
            <li>A <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19270209-01.2.3&srpos=1&e=-------en-20--1--txt-txIN-%22Christian+Association%22+%22Aubrey%22-------" target="_blank">1926 article</a> reveals plans to survey students about chapel organization. Vassar has been reflective about this for nearly a century.</li>
            <li>In 1927 Vassar was <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19270525-01.2.6&srpos=4&e=-------en-20--1--txt-txIN-chaplain+Aubrey-------" target="_blank">surveying students about chapel and chaplaincy</a>.</li>
            <li>In the 1930s, the Vassar Community Church <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19350306-01.2.3&srpos=6&e=-------en-20--1--txt-txIN-chaplain-------" target="_blank">surveyed faculty and students about the desirability of having a chaplain</a> (most schools did not have chaplains until the mid-twentieth century, according to Seymour Smith in <em>The American College Chaplaincy</em>).</li>
            <li>In a 1949 article, the <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19490427-01.2.5&srpos=12&e=-------en-20--1--txt-txIN-chaplain-------" target="_blank"> College Chaplain discusses the role</a>, which includes worship and pastoral counseling (the chaplain is part of Vassar’s “mental hygiene unit”).</li>
            <li>In 1955, Vassar’s chaplain <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19550420-01.2.11&srpos=2&e=-------en-20--1--txt-txIN-chaplain+Bonthius-------" target="_blank">celebrates communion</a> with religion professor Richard Niebuhr (part of the famous mainline family.</li>
            <li>The National Association of College and University Chaplains <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19560411-01.2.4&srpos=8&e=-------en-20--1--txt-txIN-chaplain-------" target="_blank">held its ninth meeting</a> at Vassar in 1956.</li>
            <li>In 1981, a faculty member <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19811030-01.2.4&srpos=2&e=-------en-20--1--txt-txIN-chaplain-------" target="_blank">submitted a proposal</a> to end chaplaincy.</li>
            <li>There was concern about the lack of a chaplain in 1985 (a vacant position). Some saw this as a chance to <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19850927-01.2.3&srpos=3&e=-------en-20--1--txt-txIN-chaplain-------" target="_blank">rethink the role</a>.</li>
            <li>An article from 1985 on <a href="https://newspaperarchives.vassar.edu/?a=d&d=vcunscr19851001-01.2.11&srpos=17&e=-------en-20--1--txt-txIN-chaplain-------" target="_blank">rethinking chaplaincy</a> is printed in the Vassar paper which mentioned the tendency of history to repeat itself on this topic at Vassar.</li>
            <li>In 1986, <a href="https://newspaperarchives.vassar.edu/?a=d&d=miscellany19860404-01.2.28&srpos=9&e=-------en-20--1--txt-txIN-chaplain-------" target="_blank">"How a Chaplain is Axed"</a> is published in the Vassar paper.</li>
            </ul>
            </div>`,
          ],
          text: [
            `<p>Vassar has employed a College Chaplain since 1938. Over its first several decades, the chaplaincy was led by a series of male Protestant ministers. Over time, the chaplaincy and its leadership shifted to become more intentionally multi-faith, expanding the staff to include a Director for Jewish Student Life, and part-time advisors for the Catholic, Episcopal, Buddhist, Evangelical, and Muslim communities. To reflect this expanded multi-faith approach, the office changed its name to the Office of Religious and Spiritual Life (later adding Contemplative Practices), and stopped using the term “chaplains” to describe its staff.</p> <p>In 2017, when the <a href="https://religiousandspirituallife.vassar.edu/" target="_blank" rel="noopener noreferrer">Office of Spiritual and Religious Life and Contemplative Practices</a> launched their design thinking process, the office supported almost a dozen student religious and spiritual groups, but was often seen as peripheral to campus life, primarily and interest group for religious students, and generally “white.” While there were many periods of strength and creativity, student groups regularly struggled to attract members and maintain organization.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        8: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Luminaria walking meditation on the chapel lawn.",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Luminaire_meditation_11_BL_1807-standard.jpg",
              order: 0,
            },
            {
              alt:
                "RSLCP staff: Sam Speers, Liz Aeschlimann, Nora Zaki, and Annie Sampugnaro, with their annual exam week “Cookie Wagon” in the library.",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/RSLCP+staff+-+Sam+Speers+Liz+Aeschlimann+Nora+Zaki+and+Annie+Sampugnaro.jpg",
              order: 1,
            },
          ],
          layoutNumber: 7,
          navigation: [
            { available_scene: "8.1", current_scene: "8", text: "Continue" },
          ],
          scene_number: "8",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            "<p>Motivated by a desire to reach a greater number of students, RSLCP turned to design thinking to identify student needs and interests and reimagine chaplaincy at Vassar. Anecdotally, they knew that there were key student populations they were not reaching, and they recognized that while significant numbers of students may not feel comfortable explicitly religious settings, many were seeking out other forms of spiritual or contemplative practice, such as astrology and meditation. </p>",
          ],
          title: null,
          videos: [],
          audio: [],
        },
        8.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "9", current_scene: "8.1", text: "Continue" },
          ],
          scene_number: "8.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            "<p>In 2018, Liz Aeschlimann, Director for Jewish Student Life, and Sam Speers, Associate Dean for Religious and Spiritual Life and Contemplative Practices applied to participate in a design thinking process guided by the Organizational Design Lab, a partnership of Tulane Hillel and Hillel International.</p><p> Over the next two years, Liz and Sam, along with Nora Zaki, the Advisor for Muslim Student Life who joined the office in 2019, used design thinking to develop a new approach to their work.</p>",
          ],
          title: null,
          videos: [
            {
              data: "https://www.youtube.com/embed/-TjRjmdgZag",
              alt: "What is design thinking?",
            },
          ],
          audio: [],
        },
        9: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Yonah Schiller",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/110117_yonah-schiller_005_800_reuse.jpg",
              order: 0,
            },
            {
              alt: "Charlie Buckholtz",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/buckholtz.headshot-2000x1334.jpg",
              order: 1,
            },
          ],
          layoutNumber: 7,
          navigation: [
            { available_scene: "10", current_scene: "9", text: "Continue" },
          ],
          scene_number: "9",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>Further Reading</h3><a href="https://www.tulanehillel.org/the-organizational-design-lab-a-report/" target="_blank" rel="noopener noreferrer">The Organizational Design Lab: A Report</a>`,
          ],
          text: [
            `<p>Since 2016, The Organizational Design Lab, led by Yonah Schiller and Charlie Buckholtz, has coached 16 Hillel teams to redesign their organizations using design thinking. The Vassar team jumped at the chance to participate in the two year process, which included annual workshops, site visits each semester, and biweekly coaching calls. Unlike other ODL campuses in the national Hillel cohort, however, RSLCP decided to embrace the design-thinking approach as an inter-religious office-- for Jewish life and its office program as a whole.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        10: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt:
                "That's incorrect. Design thinking is all about iteration. Any any point, you can return to a prior step in order to make adjustments or learn more.",
              answer: true,
              content_type: 5,
              data: "True",
              order: 0,
              question_type: null,
              scene_number: "10",
              sidebar: false,
            },
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>Design thinking is a linear methodology: you should progress through all of the steps before returning to any previous step.</p>",
              order: 0,
              question_type: 1,
              scene_number: "10",
              sidebar: false,
            },
            {
              alt:
                "That's right. Design thinking is all about iteration. Any any point, you can return to a prior step in order to make adjustments or learn more.",
              answer: true,
              content_type: 5,
              data: "False",
              order: 1,
              question_type: null,
              scene_number: "10",
              sidebar: false,
            },
          ],
          images: [
            {
              alt: "Discover",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/everyday-basics-bxdpM0mpgyo-unsplash.jpg",
              order: 0,
              text: `Discovery involves learning about the problem at hand. Who are the "users" of your program and what are their expectations? In the Discovery phase, design thinking practictioners conduct interviews and empathize with their end users (in this case, students).`,
            },
            {
              alt: "Define",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/charles-deluvio-Wd3DG2ABwzE-unsplash.jpg",
              order: 1,
              text:
                "In the Definition phase, you syntheize the findings from user interviews and observations and begin to pin point a problem.",
            },
            {
              alt: "Ideate",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/you-x-ventures-m2TU2gfqSeE-unsplash.jpg",
              order: 2,
              text:
                "Ideation involves thinking of possible solutions to the problem you identified in the Define phase. Consider Ideation to be a big brainstorming session where every possible solution is considered. The goal is to come up with unique ideas that are inspired by users' needs - so hold back judgement of ideas at this stage.",
            },
            {
              alt: "Prototype",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/halacious-tZc3vjPCk-Q-unsplash.jpg",
              order: 3,
              text:
                "Prototyping is the phase where you begin to build a solution! Prototyping often involves building small scale solutions and getting them in front of users quickly so that they can try them out.",
            },
            {
              alt: "Evaluate",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/jess-bailey-ycTvvg1mPU4-unsplash.jpg",
              order: 4,
              text:
                "Prototypes must be evaluated by users for the design-thinking process to work. In the Evaluation phase, users provide feedback about your prototypes. Design thinking practictioners can also evaluate the efficacy of prototypes, but the opinions of the users should remain central.",
            },
          ],
          layoutNumber: 5,
          navigation: [
            { available_scene: "11", current_scene: "10", text: "Continue" },
          ],
          scene_number: "10",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>RSCLP’s design thinking process was broken down into five stages: Discovery, Defining, Ideation, Prototyping, and Evaluation.</p>  <p><a href="https://www.interaction-design.org/literature/article/what-is-design-thinking-and-why-is-it-so-popular">The Interaction Design Foundation</a> defines design thinking as: <blockquote> an iterative process in which we seek to understand the user, <span><a href="https://www.interaction-design.org/literature/topics/challenge-assumptions">challenge assumptions</a>,</span> and redefine problems in an attempt to identify alternative strategies and solutions that might not be instantly apparent with our initial level of understanding. At the same time, Design Thinking provides a solution-based approach to solving problems. It is a way of thinking and working as well as a collection of hands-on methods.</blockquote></p> <p>In order to challenge assumptions and come up with creative solutions to problems, it’s important that any design thinking process begins with a deep inquiry into “users’” or constituents’ needs before any problem is defined by the research team. At any point in the process, the team may return to a prior step. Design thinking is all about iterating upon ideas based on user feedback.</p><p>Click on each step of this process to read its definition.</p>`,
          ],
          title: "The process",
          videos: [],
          audio: [],
        },
        11: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "12", current_scene: "11", text: "Continue" },
          ],
          scene_number: "11",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>With the help and coaching of Charlie and Yonah at their first Organizational Design Lab training, the RSCLP staff began to internalize the mindset of design thinking including: </p><ul><li>Questioning the default to programming and the tendency to measure success by the amount of activity, rather than the true impact</li><li>Realizing that if people weren’t showing up to events, it was not a matter of apathy or “disengagement,” but rather a gap in the staff’s understanding of what students wanted and needed</li><li>Being open to receiving criticism and questioning “the way we’ve always done it”</li><li>A mentality of experimentation: everything is an opportunity to gather data and “fail forward”</li><li>A bias towards action. <strong>When in doubt, do something!</strong></li>
            </ul>`,
          ],
          title: "Grounding Principles",
          videos: [],
          audio: [],
        },
        12: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Liz Aeschlimann with students",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/0020-19-04-kr-passover-vassar-8552.jpg",
              order: 0,
            },
          ],
          layoutNumber: 2,
          navigation: [
            { available_scene: "13", current_scene: "12", text: "Continue" },
          ],
          scene_number: "12",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>The Vassar team began the design process with several months of Discovery: deepening their understanding of their current impact and the lives and needs of the student population.</p><p> They began the discovery process by examining their office's slogan, mission and programs.</p><ul><li> How many students were attending their programs?</li><li> Which students were showing up, and which students weren’t?</li><li> How did the cross-section of students they were serving line up with the population of the campus as a whole?</li></ul>`,
          ],
          title: "Discovery",
          videos: [],
          audio: [],
        },
        13: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "A Vassar Muslim Student Association meeting",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/unnamed.jpg",
              order: 0,
            },
            {
              alt: "Two students using the library's Prayer Room",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/prayerroom.jpg",
              order: 1,
            },
            {
              alt: "A group of Vassar students sitting on a couch and laughing",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/Jewish+students+-+I+used+this+picture+to+illustrate+our+Shabbat+design+team+and+wendnesday+night+dinners+prototype.jpg",
              order: 2,
            },
          ],
          layoutNumber: 2,
          navigation: [
            { available_scene: "14", current_scene: "13", text: "Continue" },
          ],
          scene_number: "13",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>By closely examining which students were attending RSCLP programs and those they saw less of, they decided that they needed to better understand the experience of Athletes, Students of Color, STEM majors, Activists, and Students interested in contemplative practices.</p>`,
          ],
          title: "Discovery: Understanding the campus",
          videos: [],
          audio: [],
        },
        14: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "15", current_scene: "14", text: "Continue" },
          ],
          scene_number: "14",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>RSCLP staff had relationships with a number of students that they thought would be useful to interview in these categories, and turned to their networks to connect to others. Supportive faculty and administrators were key in connecting them to students to interview in these categories.</p>`,
            `<article><div><h3><strong>Subject: Your perspective on STEM experience</strong>
            </h3><p>Hi _____,</p><p>The Office of Religious and Spiritual Life and Contemplative Practices is going through a process to better understand how we can meet the needs of a broad range of students. One area we think we could be doing better is in supporting students in STEM majors, and _ [faculty member] __ suggested I reach out to you.</p><p>I'd love to have a chance to talk with you more about your experiences so we can be more responsive to student needs and interests. Could I buy you some coffee or tea, pick your brain, and get your perspective?</p><p>All the best,<br/>Liz</p></div></article>`,
          ],
          title: "Discovery: Reaching students",
          videos: [],
          audio: [],
        },
        15: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "16", current_scene: "15", text: "Continue" },
          ],
          scene_number: "15",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Closely following the Discovery Interview Guide created by the Organizational Design Lab, they focused on several areas of questioning. Explore the Discovery Interview Guide below.</p>`,
            `<article> <h4>ORGANIZATIONAL DESIGN LAB (ODL)<br/><em>A Partnership Between Tulane Hillel and Hillel U</em></h4> <h4>Discovery Questions For Student Interviews</h4></article> <section> <blockquote> <h4>What is your life like?</h4>  <h4> What do you care about & invest your time/identity in?</h4>  <h4>What is your relationship to Jewish/Religious/Spiritual identity?</h4>  <h4>What is your impression of the Jewish community and/or RSLCP?</h4> </blockquote>  <blockquote> <h4>Why did you choose Vassar?</h4> <ul> <li> Are you enjoying your time at Vassar?</li> <li>What would you change about your College experience?</li> <li>What do you find challenging about being a student at Vassar?</li> <li>Do you find you have a sustainable work/life (school/life) balance?</li> <li>How many hours a week on average do you put into class and studying?</li> </ul> </blockquote>   <blockquote <h4>What are your hobbies? What do you like to do in your free time? Why do you choose to spend your free time on _____?</h4> <ul> <li>Why did you join?</li> <li>What do you like/not like about your extra-curricular involvement?</li> <li>What value(s) does involvement in your extra-curricular(s) provide?</li> <li>What value(s) are you not getting from your extra-curricular involvement that you would want?</li> <li>What did you spend your time doing in high school?</li> </ul> </blockquote> <blockquote><h4>What makes you nervous/uneasy/anxious?</h4>  <h4>What makes you happy?</h4>  <h4>What communities do you identify with?</h4>  <h4>What (if any) are your plans after you graduate?</h4>  <h4>Where do you hang out? What does your day look like?</h4> </blockquote> <blockquote> <h4>What is your impression of RSL/Jewish life on campus? </h4> <ul> <li>What was your Jewish/religious/spiritual experience like growing up?</li> <li>What is a strong, positive Jewish memory for you? A negative memory?</li> <li>What are you looking for in a Jewish community in college?</li> </ul> </blockquote><blockquote> <h4>Identify 3 friends who don’t like or don’t come to RSLCP that we should talk with.</h4></blockquote>  <blockquote> <h4>For Campus Leaders:</h4> <ul> <li>What motivated you to take on a leadership position in college?</li> <li>What value do you see in your position?</li> <li>What are some skills that this leadership position has taught you?</li> <li>What are important values to you?</li> <li>Where do you spend most of your time?</li> <li>What is your awareness or impression of RSLCP? </li> </ul> </blockquote> </section> <section> "Re-designing Campus Chaplaincy: Transforming student outreach through design-thinking" /  Elizabeth Aeschlimann and Sam Speers, Vassar College / ACURA 2019 / eaeschlimann@vassar.edu / saspeers@vassar.edu  </section>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        16: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt:
                "Student baking bread in the weekly Challah for Hunger program.",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Challah_Hunger_1012_BL_9152-standard.jpg",
              order: 0,
            },

            {
              alt: "The Christian Fellowship's Christmas Party",
              image:
                "https://religiousandspirituallife.vassar.edu/assets/images/slideshow-hp/Christian_Fellowship_1012_BL-8942-standard.jpg",
              order: 1,
            },
            {
              alt: "A Vassar Catholic community Mass",
              image:
                "https://religiousandspirituallife.vassar.edu/assets/images/slideshow-hp/Catholic_Mass_10_TS_8-standard.jpg",
              order: 2,
            },
            {
              alt: "Students on an interfaith panel about head coverings",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/students+on+an+interfaith+panel+about+head+covering+-+this+could+illustrate+before+the+design+process+or+the+religious+group+leaders.jpg",
              order: 3,
            },
          ],
          layoutNumber: 7,
          navigation: [
            { available_scene: "17", current_scene: "16", text: "Continue" },
          ],
          scene_number: "16",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>The full and complex picture of students’ lives that emerged through these Discovery interviews underscored for Sam and Liz how much they missed when they simply asked questions such as “What are you interested in?” or “What do you want to see in Jewish life?”</p>
            <p>The Vassar team also found that they had to push back against students’ tendency to narrow their answers to what they assumed to be relevant to “religious” or “spiritual” life. In interviews, they often had to say explicitly, “I really don’t care about getting you to come to services--I want to understand your life,” or “I want to hear your thoughts about RSLCP, but I want to hear about what you care about and how you spend your time first.” </p>`,
            `<p>By encouraging students to share how they spent their time, where they liked to hang out on campus, and what made them anxious, RSLCP gained valuable insights about how they could support students’ flourishing in ways students might not have considered relevant.</p><p>Some of the most effective questions were things like:</p><ul><li>What do you invest your time and energy in?</li><li>How did you spend your time in high school?</li><li>What led you to get involved with your current activities and groups?</li><li>What makes you anxious? What brings you joy?</li><li>What is your impression of Religious and Spiritual Life and Contemplative Practices at Vassar?</li></ul>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        17: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 7,
          navigation: [
            { available_scene: "18", current_scene: "17", text: "Continue" },
          ],
          scene_number: "17",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [``],
          title: "Explore student responses to some of these questions below.",
          videos: [
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://www.youtube.com/embed/6TV8Wju0SmI",
              order: 0,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://www.youtube.com/embed/v1DxHaBYq38",
              order: 1,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://www.youtube.com/embed/eTU7QbrfDLk",
              order: 2,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://www.youtube.com/embed/BQfn9NUH03A",
              order: 3,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://www.youtube.com/embed/ykwkxcIgDr8",
              order: 4,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://www.youtube-nocookie.com/embed/UI3deYMYpIw",
              order: 5,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
          ],
          audio: [],
        },
        18: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "19", current_scene: "18", text: "Continue" },
          ],
          scene_number: "18",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>In many institutions, chaplains are situated in a challenging middle position. In a college, they are responsible to the well-being and best interests of their students. Beacuse chaplains often have a direct line to the college President and are seen to be a voice of moral authority, they are sometimes called upon to advocate for students, potentially putting them in conflict with the institution. At the same time, chaplains are responsible to the institution, the chaplains' employer, and their colleagues in the administration.</p><blockquote>Consider potential allies and supporters with a similar amount of authority. Having a broad base of support is often more compelling to decision-makers than your voice alone. Furthermore, collaboration will broaden your reach and increase your impact.</blockquote>

            <p>Reaching out to potential allies anywhere along the organizational hierarchy, it is helpful to consider two things: self-interest and relationships. How might a new focus on community building be in the interest of the Dean of the College? How might combating isolation appeal to Counseling Services or Residential Life? In addition, your personal relationships, and the trust and credibility built up over time will also carry weight as you ask for someone's support. </p>
            
           <p>As you begin to make changes to your work that may have wider impact than your department alone, it can be helpful to map out your institution to identify potential partners, allies, and supporters, as well as any places you might encounter resistance to change.</p>`,
          ],
          title: null,
          videos: [
            {
              alt: `Using your organizational chart as an organizing tool`,
              answer: true,
              content_type: 1,
              order: 0,
              question_type: null,
              scene_number: "19",
              sidebar: false,
              data: "https://www.youtube-nocookie.com/embed/TacZ20P57Ng",
            },
          ],
          audio: [],
        },
        19: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data: `<p>What if the Dean of the College and the College President had <em>not</em> been supportive? How might you have tried to convince them to support changes in your organization?</p><ul><li>Why might the changes you are advocating be in their self-interest?</li>
              <li>What might be holding them back from supporting these changes? Are their conflicting goals? Other stakeholders with a different vision?</li><li>Who are your allies? </li></ul>`,
              order: 0,
              question_type: 2,
              scene_number: "19",
              sidebar: true,
            },
          ],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "20", current_scene: "19", text: "Continue" },
          ],
          scene_number: "19",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>At Vassar, RSCLP staff were well supported in their design process. But what if they had been met with resistance?</p><p>Making change within institutions, which are notoriously resistant to disturbing the status quo, can be a daunting task, and support from colleagues and those with institutional power and influence is crucial. Recruiting support from those above you in the organizational hierarchy--those who control the resources, vision, and policies of the institution--can make all the difference. In the case of a college, an enthusiastic President can direct resources to the chaplaincy and encourage collaboration from others across the institution. A resistant college President, however, can slow and stymie a chaplain's efforts every step of the way.</p>`,
          ],
          title: null,
          videos: [
            {
              alt: `Dean Carlos Alamo discusses why he has supported RSLCP’s design process`,
              answer: true,
              content_type: 1,
              order: 0,
              question_type: null,
              scene_number: "11",
              sidebar: false,
              data: "https://www.youtube-nocookie.com/embed/fwBYLW_sDzM",
            },
          ],
          audio: [],
        },
        20: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: `Rev. Sam Speers working through the "How Might We" statement`,
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/Design+process+-+articulating+our+insights+and+how+might+we+statement.png",
              order: 0,
            },
          ],
          layoutNumber: 4,
          navigation: [
            { available_scene: "21", current_scene: "20", text: "Continue" },
          ],
          scene_number: "20",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>After interviewing 30 students about their experiences at Vassar, the team transitioned from the Discovery phase to Defining the Problem. They looked back through their interview notes and identified key insights. They used sticky notes to analyze their interview insights and start to formulate some cohesion around themes and student needs.</p> 
            
            <article><p>Some key insights from the discovery process:</p> <ul> <li>Students are seeking ways to <b>escape toxic communal culture </b>(busyness and pressure to succeed, constant academic and social scrutiny and evaluation, pressure to <b>compartmentalize or suppress their own suffering or backgrounds</b> that don’t fit into the dominant culture)</li> <li>Students are frustrated by <b>social fragmentation</b>, with high barriers between social groups and lack of fluidity to move between groups.</li> <li>Students feel they must <b>"perform"</b> their identities to match social expectations.</li> <li>Students are seeking <b>integration</b> (Being, authenticity, full self).</li> <li><b>Students are finding the cracks</b>: Creating their own rituals, ways of escaping toxicity, expressing themselves, & connecting deeply</li> <li>Students are <b>seeking deep meaningful connections.</b> </ul></article>`,
          ],
          title: "Definition: Defining the problem",
          videos: [],
          audio: [],
        },
        21: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: `Rev. Sam Speers working through the "How Might We" statement`,
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/Design+process+-+articulating+our+insights+and+how+might+we+statement.png",
              order: 0,
            },
          ],
          layoutNumber: 2,
          navigation: [
            { available_scene: "22", current_scene: "21", text: "Continue" },
          ],
          scene_number: "21",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            ` <p>From these insights, RSLCP crafted a “How Might We” statement that defined the problem they were trying to solve.</p><blockquote>How might we equip students with the capacity to build a culture of belonging and difference that resists fragmentation and burnout, and become a hub of connection and growth where students can be their messy, joyful, full selves?
            </blockquote>`,
          ],
          title: `Ideation: The "How Might We?" statement`,
          videos: [],
          audio: [],
        },
        22: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Pratt Fellows",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/pratt+fellows+poster-1.png",
              order: 0,
            },
            {
              alt: "Pratt House",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/Pratt_House%2C_Vassar_College%2C_August_2014.jpg",
              order: 1,
            },
            {
              alt: "Shabbat Dinners",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/Vassar-shared/Wednesday+night+dinners+poster+-+design+prototype.png",
              order: 2,
            },
          ],
          layoutNumber: 10,
          navigation: [
            { available_scene: "23", current_scene: "22", text: "Continue" },
          ],
          scene_number: "22",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>With the “How Might We” question as a guide, Sam, Liz, and Nora developed three initial prototypes, experiments that would help them to learn more about the most effective ways to equip students to build a capacity of belonging in difference. Explore the prototypes they developed below.</p><blockquote>How might we equip students with the capacity to build a culture of belonging and difference that resists fragmentation and burnout, and become a hub of connection and growth where students can be their messy, joyful, full selves?</blockquote>`,
          ],
          title: "Prototyping",
          videos: [],
          audio: [],
        },
        23: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "24", current_scene: "23", text: "Continue" },
          ],
          scene_number: "23",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>The design thinking process is ongoing: RSCLP continues to do discovery interviews, revisit and refine the “How Might We” statement, and develop new prototypes. Because the goal is to respond to the current needs of their students, they must continue to ask what is happening and what is needed in the moment.</p> <p>Watch the conversation between Sam Speers and Liz Aeschlimann, reflecting on the impacts of the design thinking process and how it changed their work.</p>`,
          ],
          title: "Evaluation",
          videos: [
            {
              answer: true,
              content_type: 1,
              order: 0,
              question_type: null,
              scene_number: "33",
              sidebar: false,
              data: "https://www.youtube-nocookie.com/embed/26Z3ZnI3T6E",
              alt: `"This is a better way of doing our work."`,
            },
            {
              answer: true,
              content_type: 1,
              order: 0,
              question_type: null,
              scene_number: "33",
              sidebar: false,
              data: "https://www.youtube-nocookie.com/embed/gEcZWz3uhKQ",
              alt: `"We've been able to reach a much broader segment of the student population"`,
            },
          ],
          audio: [],
        },
        24: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data: `<p>Take a moment to reflect upon these closing questions and choose one to answer.</p>
                <ul>
                <li>How do you relate to the idea of experimentation and "failing forward"? When do you resist change? When do you seek it out?</li>
                <li>How might design thinking be useful in your context? What are the benefits to using design thinking in a chaplaincy context? What might be possible drawbacks?</li>
                <li>Which of your "users," those who you serve as chaplain, are not accessing your resources? What are some questions could you ask them to better understand their lives and needs?</li>
                <li>How does change happen in your institution? Who are possible allies and why is your success in their interest? Who might be resistant to change? </li> 
                </ul>`,
              order: 0,
              question_type: 2,
              scene_number: "24",
              sidebar: false,
            },
          ],
          images: [
            {
              alt: "Discover",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/everyday-basics-bxdpM0mpgyo-unsplash.jpg",
              order: 0,
              text: `Discovery involves learning about the problem at hand. Who are the "users" of your program and what are their expectations? In the Discovery phase, design thinking practictioners conduct interviews and empathize with their end users (in this case, students).`,
            },
            {
              alt: "Define",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/charles-deluvio-Wd3DG2ABwzE-unsplash.jpg",
              order: 1,
              text:
                "In the Definition phase, you syntheize the findings from user interviews and observations and begin to pin point a problem.",
            },
            {
              alt: "Ideate",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/you-x-ventures-m2TU2gfqSeE-unsplash.jpg",
              order: 2,
              text:
                "Ideation involves thinking of possible solutions to the problem you identified in the Define phase. Consider Ideation to be a big brainstorming session where every possible solution is considered. The goal is to come up with unique ideas that are inspired by users' needs - so hold back judgement of ideas at this stage.",
            },
            {
              alt: "Prototype",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/halacious-tZc3vjPCk-Q-unsplash.jpg",
              order: 3,
              text:
                "Prototyping is the phase where you begin to build a solution! Prototyping often involves building small scale solutions and getting them in front of users quickly so that they can try them out.",
            },
            {
              alt: "Evaluate",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/organizational/icons/jess-bailey-ycTvvg1mPU4-unsplash.jpg",
              order: 4,
              text:
                "Prototypes must be evaluated by users for the design-thinking process to work. In the Evaluation phase, users provide feedback about your prototypes. Design thinking practictioners can also evaluate the efficacy of prototypes, but the opinions of the users should remain central.",
            },
          ],
          layoutNumber: 5,
          navigation: [
            { available_scene: "25", current_scene: "24", text: "Continue" },
          ],
          scene_number: "24",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Design thinking is one methodology you can use to understand your organization’s needs and begin to make change to improve your chaplaincy. While your organization may have different needs, constraints, or opportunities than Vassar, you can draw upon this example, and the plethora of resources about design thinking and organizational leadership, to begin your own change process.</p>`,
          ],
          title: "Conclusion",
          videos: [],
          audio: [],
        },
        25: {
          checkpoint: false,
          last: true,
          checkpoints: [],
          images: [],
          layoutNumber: 6,
          navigation: [],
          scene_number: "25",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You finished this lesson! Take a moment to download your responses to the questions you answered along the way. You can print them for future review or to show to your instructor if you are using this lesson in a class.</p>`,
            `<div style="background-color: white;
              padding: 10px;
              border-radius: 10px;
              margin-top: 10vh;"><h3 style="color: black">Want to learn more?</h3><p>Here are some additional resources: </p>
              <ul>
              <li><a href="https://www.heri.ucla.edu/monographs/TheAmericanFreshman2014-Expanded.pdf" target="_blank">UCLA American Freshman Survey</a>: For data on religion and spirituality, see pages 9 and 10</li>
              <li><a href="https://spirituality.ucla.edu/docs/reports/Spiritual_Life_College_Students_Full_Report.pdf" target="_blank">UCLA Spirituality Survey</a>: For data on the prevalence of spirituality (not necessarily religious affiliation) among students</li>
              <li><a href="https://www.pewforum.org/2019/10/17/in-u-s-decline-of-christianity-continues-at-rapid-pace/" target="_blank">In U.S., Decline of Christianity Continues at Rapid Pace</a></li>
              <li><a href="https://www.pewresearch.org/fact-tank/2015/05/12/millennials-increasingly-are-driving-growth-of-nones/" target="_blank">Millennials increasingly are driving growth of ‘nones’</a></li>
              <li><a href="https://dschool.stanford.edu/resources" target="_blank">Stanford Design School: Tools for Taking Action</a></li>
              <li><a href="https://designthinking.ideo.com/resources" target="_blank">IDEO: Design thinking resources</a></li>
              <li><a href="https://er.educause.edu/articles/2015/1/using-design-thinking-in-higher-education" target="_blank">"Using Design Thinking in Higher Education"</a></li>
              <li><a href="https://ejewishphilanthropy.com/design-thinking-techniques-for-synagogues-lets-talk-tachlis/" target="_blank">"Design Thinking Techniques for Synagogues: Let’s Talk Tachlis!"</a></li>
              </ul></div>`,
          ],
          title: "Lesson complete",
          videos: [],
          audio: [],
        },
      };
      return data;
    } else if (action.payload === 4) {
      let data = {
        1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "A resting place",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/brandi-ibrao-n3z6AhIbXVE-unsplash.jpg",
              order: 0,
            },
          ],
          layoutNumber: 3,
          navigation: [
            { available_scene: "2", current_scene: "1", text: "Continue" },
          ],
          scene_number: "1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: "Affirming the sacredness of (a) life",
          videos: [],
          audio: [],
        },
        2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              image:
                "https://d38v7trvdc57zc.cloudfront.net/meaning-making/candles.gif",
              alt: "",
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "3", current_scene: "2", text: "Continue" },
          ],
          scene_number: "2",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>A note on meaning-making</h3><p>Some chaplains speak of guiding people in times of grief and loss as the theological dimension of their work. Chaplains study religious and spiritual traditions and bring the wisdom and practices of these traditions to assist persons and communities in interpreting their life experiences. Working in religiously diverse settings, chaplains learn to interact with differing worldviews, guide people in making meaning of their experiences by drawing on the wisdom of spiritual teachings and sacred texts.</p>`,
          ],
          text: [
            `<p>Chaplains accompany individuals, families, and communities in times of grief and loss. They provide care in private moments but also leadership in public moments. They often step into situations where words fail and offer meaningful ways of naming and holding pain. This work of meaning-making is core to chaplaincy training and is often supported by spiritual and/or religious worldviews that chaplains explore in formal studies.</p> `, `<p> A chaplain’s work is not isolated to death and loss, but these moments shed light on their unique ability to confront pain without looking away. Part of this work involves creating rituals that register life’s most challenging moments as sacred. </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        3: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "4", current_scene: "3", text: "Continue" },
          ],
          scene_number: "3",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>In this lesson, we emphasize the importance of paying close attention to the physical environment—to the smells, sounds, and feel of spaces and places. All of these components are ingredients for creating meaningful rituals.</p><p>We also emphasize a chaplain’s ability to assess how a person’s life challenges may be impacting them in the present. These experiences may have produced shame, guilt, and judgment. They may also be tied to religious beliefs. These challenges are often deeply shaped by systems and institutions that render them vulnerable and without resources. (In some sectors, these are called ‘spiritual assessments.')</p>`,
          ],
          title: "Making meaning",
          videos: [],
          audio: [],
        },
        4: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "5", current_scene: "4", text: "Continue" },
          ],
          scene_number: "4",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>This lesson focuses on the chaplain’s role in:</p><ul><li>Affirming the sacredness of life</li><li>Addressing spiritual struggles, trauma, and moral injury</li><li>Creating rituals in response to death and loss</li></ul><p>This case features chaplaincy in its most de-institutionalized form—as ministry to persons living on the streets. It underscores a core truth at the heart of all chaplaincy work: the belief in the fundamental dignity and sacredness of all life. This affirmation is essential to the work of chaplaincy in all sectors, but here, it cannot be taken for granted. </p>`,
          ],
          title: "Affirming the sacredness of life",
          videos: [],
          audio: [],
        },
        5: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "6", current_scene: "5", text: "Continue" },
          ],
          scene_number: "5",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Street chaplaincy also involves confronting under-resourced populations. An important part of entering this work is to notice your discomfort and face assumptions about this community that you may not be aware that you held. </p><p>As a result of this lesson, you should be better equipped to:</p><ul><li>Assess how someone’s spiritual and religious history is informing a present situation</li><li>Identify key ingredients in creating meaningful rituals</li><li>Consider the surrounding environment and its impact on chaplaincy encounters</li><li>Distinguish between trauma, moral injury, and spiritual struggles</li></ul>`,
          ],
          title: "What can you expect to take away from this lesson?",
          videos: [],
          audio: [],
        },
        6: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Common Cathedral outdoor church",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/meaning-making/common-cathedral/common-cathedral-circle.jpg",
              order: 1,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "7", current_scene: "6", text: "Continue" },
          ],
          scene_number: "6",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>What is Street Chaplaincy?</h3><p>Street chaplaincy is a form of ministry that combines the practical aspects of homeless outreach with the spiritual and pastoral aspects of chaplaincy. In other words, it combines <em>caring for the physical body</em> by helping people access resources and housing with <em>caring for the soul</em> by being a vehicle for comfort, hope, love, community, justice, and restoration. Street chaplaincy seeks wholeness and healing in margins by meeting people where they are and making resources and pastoral care accessible to them. It faithfully and creatively embodies God’s love in the margins and concretely responds to oppression, loneliness, isolation, trauma, injustice, and suffering and works toward the resurrection of the living dead.</p><p>"Perspective of a Street Chaplain" <br/>
          - Lindsey Krinks, Co-Founder and Interim Co-Director of Open Table Nashville</p>`,
          ],
          text: [
            `<p>You are a chaplain to folks sleeping out on the streets and in shelters. In this role, you offer one-on-one pastoral care as well as facilitate group space to foster relationships within the unhoused community. One of your groups gathers on Sunday mornings prior to a worship service, where folks check in with one another, discuss current events, and plan any spiritual or secular celebrations and gatherings that may take place throughout the year. This is often called "outdoor church."</p>`,
          ],
          title: "The scene: Sunday morning",
          videos: [],
          audio: [],
        },
        7: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: `Two people on the street. One sitting on the ground, one in a wheelchair. Both are facing away from the camera. Image credit: Kenny Breedlove`,
              image:
                "https://d38v7trvdc57zc.cloudfront.net/meaning-making/3747648595_f367527dee_b.jpg",
              order: 1,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "8", current_scene: "7", text: "Continue" },
          ],
          scene_number: "7",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<h3> Sunday on your way to the group, you pass parishioners on the street who have slept outside.</h3><p><em>How do you greet them? What sensitivities do you consider?</em></p>`, `<p>Knowing that folks have spent the night outside, how might you approach their physical space? Do you walk over into their sleeping area, do you wave from afar, do you offer a hug or a handshake? What boundaries of theirs might you discern together, and what boundaries of your own might you wish to assert when it comes to greeting, physical contact, and morning rituals?</p>`,
          ],
          title: null,
          videos: [],
          audio: [
            `https://d38v7trvdc57zc.cloudfront.net/meaning-making/background-city-noise.mp3`,
          ],
        },
        8: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "9", current_scene: "8", text: "Continue" },
          ],
          scene_number: "8",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p><Affirming human dignity is a central value in chaplaincy, as it is in most religious traditions and in humanist teachings.</p>

            <p>Street chaplains affirm human dignity when they consider privacy and seek consent when entering someone’s sleeping space. It is also important to consider your own needs and boundaries when approaching someone who is actively experiencing the trauma of sleeping outside.</p>
            `,
          ],
          title: "Affirming dignity",
          videos: [],
          audio: [],
        },
        9: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>What do you think it would feel like to be approached by a chaplain (especially if that person was older or younger than you, of a different ethnicity or race, of a different gender, etc.) when you are just waking up?</p>",
              order: 0,
              question_type: 2,
              scene_number: "9",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "10", current_scene: "9", text: "Continue" },
          ],
          scene_number: "9",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<section><h3>As you walk, you reflect on your own experience of “home,” and what internal and external boundaries you might need to make if that home had no physical boundaries.</h3><p>Your mind goes back to your first waking moments this morning. What was the first thing that you did? Were you safe? Was anyone else around you? Was anyone around that you don't know?</p><p>When you got out of bed, what do you reach for? Where were your belongings located? Were they where you remembered them being when you went to sleep?</p><p><em>You are acutely aware that if you did not have a safe place to be or keep your belongings, it would take a considerable amount of additional labor to simply get through your day.</em></p></section>`,
          ],
          title:
            null,
          videos: [],
          audio: [],
        },
        10: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "11", current_scene: "10", text: "Continue" },
          ],
          scene_number: "10",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>Buiding trust</h3><p>Begin the conversation by introducing yourself. Then, as with any conversation with a stranger, having some small-talk topics can be a good way to get a conversation going and build rapport. The news, the weather, any local events that are happening: these are all good topics to casually bring up with someone you’re just meeting. Some folks might tell you a lot about themselves, while others may be reluctant to even give their name. Whatever someone is comfortable with is a perfect place to start. </p>
            <blockquote>Best practice: If someone does not feel comfortable giving their name do not press them about it. However, it is essential that you remember people’s names if they share them, so if this might be difficult for you write them down somewhere. It is crucial that you remember the names people give you, so that the next time you see someone you can greet them by name. </blockquote>
            <h4>Example introductions:</h4>
            <ul>
            <li>“Hi, I’m [your name] and I’m a chaplain with [your organization]. Could I sit with you?” </li>
           <li> “Good morning, I’m [your name] and I’m a chaplain with [your organization]. I’m headed to get some coffee- want to join me?”</li></ul>`,
          ],
          text: [
            `<p>While it is important to be in touch with how <em>you</em> would like to be approached, knowing that folks on the street are contending with chronic and acute trauma means that it may be difficult to anticipate someone’s needs on any given day. For this reason, you know that it is critical to be in conversation about someone’s boundaries and preferences, and to stay open to those preferences shifting as circumstances and experiences shift.</p><p> Continual conversation, openness, and curiosity are best practices! When in doubt, invite folks on the street to lead you in understanding what they want and need.</p> <blockquote>You consider yourself a guest, and them the host.</blockquote>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        11: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "12", current_scene: "11", text: "Continue" },
          ],
          scene_number: "11",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<h3>As you continue walking, you think more about the context of your work.</h3> <p>When you are out on the street, it can be difficult to find private space to have sensitive conversations with someone. Vehicle or foot traffic impacts your interactions: as noise interferes with your ability to engage in conversation and pedestrians walk all around you. </p><p>You often think about the sights, sounds, smells, and other senses that you engage while you work. The business of the street can be a hindrance to your chaplaincy work, but you also try to incorporate the environment around you into your work.</p>`,
          ],
          title:
            null,
          videos: [
            {
              data: `https://d38v7trvdc57zc.cloudfront.net/meaning-making/Pexels+Videos+2880.mp4`,
              alt: null,
            },
          ],
          audio: [
            `https://d38v7trvdc57zc.cloudfront.net/meaning-making/city-noises-louder.mp3`,
          ],
        },
        12: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "Context matters.",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/meaning-making/context+matters.png",
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "13", current_scene: "12", text: "Continue" },
          ],
          scene_number: "12",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>The way that you show up for your parishoners really depends on your context and the choices that you make to best serve them. You have had to decide how you will meet those you serve: by passing by or intentionally visiting the places where people sleep in your community, or waiting for them to meet you at a central location.</p><p>Each context changes the type of chaplaincy work you do - and the boundaries that you need to hold in different locations and contexts.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        13: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "13.1", current_scene: "13", text: "Continue" },
          ],
          scene_number: "13",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<section><h3>Lately, you've been thinking a lot about how to bring other professionals across disciplines into your chaplaincy.</h3><p>What professionals across disciplines could you reach out to in your local context for thought-partnership around creating and maintaining supportive relationships with folks on the street?</p><p>You are working to be clear about your role in the ecology of support.  Since you are not trained as a housing specialist, you have been focused on helping folks connect with someone who is rather than trying to navigate the complicated and difficult housing systems yourself. Being clear about your role as a chaplain and communicating what you are trained to do in that role is a better way to serve the people you meet.</p><p>You make a note to identify case managers, medical professionals, housing specialists, or others whom you could be working with to better care for the people you meet.</p> </section>`,
          ],
          title:
            null,
          videos: [],
          audio: [],
        },
        13.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "14", current_scene: "13.1", text: "Continue" },
          ],
          scene_number: "13.1",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>Best Practices: Facilitating a discussion group</h3><ol><li><em>While you can offer topics for discussion to get the group started, it is important to let participants decide what they want to talk about.</em> Uplift the wisdom in the community by making space for participants to share their knowledge and experience with one another. While you have many resources to offer as a chaplain, participants can offer unique and important care to one another through group conversations.</li><li>
          <em>When you facilitate, keep track of who would like to speak next (and consider saying their names out loud, in order).</em> This helps everyone to be patient and feel respected as they wait to share their views. If group members disagree or feel slighted by someone’s comments, it is important for you to mediate. Jump in before a disagreement becomes escalated. 
          </li>`,
          ],
          text: [
            `<p>You arrive at your destination - the Sunday morning political advocacy group.</p><p>The political advocacy group meets in the basement of a church prior to the Sunday morning service. There are typically between 20 to 35 participants. A few longtime participants show up early to help you brew coffee and set up the chairs in a circle. The group has an open door policy, so anyone can walk in off the street and join. This means that there are often new participants, so you collaborate with longtime participants to help hold the culture of the group: one person speaking at a time, it’s okay to disagree, using “I” statements, etc.</p><p>Developing the leadership of these participants is a critical aspect of your job, as they help to set the tone of the meeting. Your role as the facilitator is not necessarily to lead the discussion, but rather to maintain enough structure that participants can have a smooth group conversation and offer support and resonance to one another.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        14: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "15", current_scene: "14", text: "Continue" },
          ],
          scene_number: "15",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: null,
          videos: [
            {
              data:
                "https://www.youtube.com/embed/2zxz1-ME_Qc?autoplay=1&rel=0",
              alt: "Meet Bill",
            },
          ],
          audio: [],
        },
        15: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "A close up of dog tags",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/meaning-making/4605367308_225e88c8f4_o.jpg",
              order: 1,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "16", current_scene: "15", text: "Continue" },
          ],
          scene_number: "15",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>In the middle of this week's discussion group, Bill opens up about his service in Vietnam. He begins to cry as he shares with the group that he feels deep shame for the harm he caused and the lives he took as a soldier.</p><blockquote>He says, "I stopped believing in God after what I saw in Vietnam, but I still believe I am going to Hell for what I did there."</blockquote><p>The man sitting next to Bill quietly puts his hand on his shoulder, and others in the group offer kind gestures and words to comfort him. Bill has never opened up like this before, and it becomes clear as the meeting goes on that his decision to share has eased some tension between him and the group.</p>`,
            `<p>You do not know what Bill experienced in Vietnam. In your encounters as a chaplain, you often know very little about details of someone’s past experiences or what motivates what they share with you in the moment. Your role is not to find out more information. Bill has done things that he was unable to reconcile with the faith he carried into his Vietnam experience. He still has a strong sense of a God who judges him for his actions in Vietnam. Imagine how you might respond to Bill’s claims about going to Hell. </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        16: {
          checkpoint: false,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>How, as a chaplain, would you facilitate the community response to what Bill shared?</p>",
              order: 0,
              question_type: 2,
              scene_number: "16",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "16.1", current_scene: "16", text: "Continue" },
          ],
          scene_number: "16",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>As Bill's chaplain, you notice how important it is that Bill shared and you also want to care for the others in the discussion group. You thank Bill for sharing his story and say to the rest of the group, <blockquote>"If anyone would like to talk about this after group, I will be here."</blockquote> </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        16.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 7,
          navigation: [
            { available_scene: "17", current_scene: "16.1", text: "Continue" },
          ],
          scene_number: "16.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>A chaplain may respond to Bill's statement during the discussion group in a variety of ways, depending on their faith, training, and experiences. Watch these three responses to Bill from Buddhist, Jewish, and Muslim chaplains.</p>`,
          ],
          title: null,
          videos: [
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://youtube.com/embed/3bL7nc_9Ym4?start=8",
              order: 0,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://youtube.com/embed/h9sBO5TTw0c",
              order: 0,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
            {
              alt: null,
              answer: true,
              content_type: 1,
              data: "https://www.youtube.com/embed/kI8-4UI_EfI",
              order: 0,
              question_type: null,
              scene_number: "17",
              sidebar: false,
            },
          ],
          audio: [],
        },
        17: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "18", current_scene: "17", text: "Continue" },
          ],
          scene_number: "17",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>Did you know?</h3><p>According to the United States Interagency Council on Homelessness, there were <a href="https://www.usich.gov/resources/uploads/asset_library/Homelessness_in_America._Focus_on_Veterans.pdf" target="_blank">40,056 homeless veterans in the US in 2018.</a> </p><p><a href="https://endhomelessness.org/resource/people-color-make-much-larger-share-homeless-veteran-population-general-veteran-population/" target="_blank">43.2% of veterans experiencing homelessness are people of color</a> compared with 18.4% of the general veteran population.</p>`,
          ],
          text: [
            `<p>After the session, you spend some time attending to participants' needs, but then go back to thinking about Bill. It is clear to you from your time with Bill that his experience in Vietnam deeply shaped him. He still wrestles with things that he did in Vietnam.
            Like many veterans, Bill carries the experiences of war with him, even decades later.</p><p>The experiences of war are extraordinary. Military training prepares recruits to carry out all of the duties of military personnel. In order to perform these duties effectively, the military understands that training requires assuming a military identity. It makes sense that one of the challenges that veterans name is the challenge of returning home and integrating back into civilian life. Those in the civilian world do not understand what veterans have seen or done. Many veterans do not speak about these experiences, fearing that they will be misunderstood or judged.</p><p>Bill’s military experience may have also shaped him in positive ways: giving him a positive source of connection with other vets. </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        18: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "18.1", current_scene: "18", text: "Continue" },
          ],
          scene_number: "18",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>As a civilian chaplain, it may be challenging to gain the trust of a military veteran.</h3><p> Zachary Moon invites chaplains to do a personal inventory when engaging military persons: (p. 1-2)</p>
          <ul>
          <li>What are my personal experiences with the military?</li>
          <li>What are my family’s experiences with the military?</li>
          <li>What are my thoughts, values, and beliefs about war?</li>
          <li>What are my thoughts and beliefs about those who serve and have served in the military?</li>
          </ul>
         <p><em>Coming Home: Ministry That Matters with Veterans and Military Families</em>, 2015</p>
         
          `,
          ],
          text: [
            `<p>Moral injury is the term that has emerged within the Veteran's Administration to describe this profound sense of rupture that veterans experience when they transgress their sense of right and wrong.</p><p>Jonathan Shay points to moral injury as a problem resulting from the chain of command. 
            But others began to speak of moral injury as a problem experienced by the veteran.</p><p>As moral beings, we make decisions all the time. We encounter moral dilemmas. We often have a feeling of being compromised or compromising our sense of right and wrong. But injury suggests more than a compromise. Instead of understanding oneself as a good person who may do bad things, moral injury is more extreme. What we have done has fundamentally changed our sense of self: I am a bad person. Unrecognizable to myself. I am no longer the good person that I once knew myself to be.</p><p><em>This injury at the core of who we are is not easily repaired.</em></p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        18.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "19", current_scene: "18.1", text: "Continue" },
          ],
          scene_number: "18.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<p>In one study of 100 veterans in VA residential PTSD programs, 74% of the veterans had difficulty reconciling their religious beliefs with their experience in combat, 51% reported having abandoned their religious faith in Vietnam, and 50% reported that guilt about experiences in Vietnam caused their religious faith to diminish (Drescher & Foy, 1995).</p>
            <h4>Further reading on trauma</h4>
            <ul>
            <li>Van der Kolk, Bessel. <em>The Body Keeps the Score: Brain, Mind, and Body in the Healing of Trauma.</em> New York: Penguin, 2014.</li>
            <li>Badenoch, Bonnie. <em>The Heart of Trauma: Healing the Embodied Brain in the Context of Relationships.</em> New York: Norton, 2018.</li>
            <li>Herman, Judith. <em>Trauma and Recovery: The Aftermath of Violence—From Domestic Abuse to Political Terror.</em> New York: Basic, 1997.</li>
            <li>Siegel, Daniel J. <em>Pocket Guide to Interpersonal Neurobiology: An Integrative Handbook of the Mind.</em> New York: Norton, 2012.</li>
            </ul>`,
          ],
          text: [
            `<p>There is often a lot of focus on post-traumatic stress disorder (PTSD) and veterans suffering from war experiences. As a chaplain, you want to consider the broader issues surrounding a veteran’s return. We know that veterans may struggle to secure housing and jobs. While deployed, their relationships with family may have changed. They may have lost key sources of support during their time in combat. Some veterans want to avoid the stigma of PTSD and do not seek support services. Consider these statistics on homelessness. What are the variables that might lead to situations of being unhoused?</p>

           <p>Bill is a white man veteran of the Vietnam era. We know that veterans from less represented groups are likely to experience additional layers of stress and trauma. Women veterans (military sexual assault) and veterans of color (racism within military ranks). </p>
            `,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        19: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "20", current_scene: "19", text: "Continue" },
          ],
          scene_number: "19",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Moral injury specifically identifies the struggle to come to terms with past harm. But it doesn’t name everything. Chaplains often accompany people who are coming to terms with many aspects of their lives. Moral injury can be expressed in religious terms. The injury has been done, and one is guilty before God for what they have done. A third party — God — enters in. This might be connected with Bill’s claim that he stopped believing in God.</p><p>Bill could be experiencing a spiritual struggle, defined as “tensions, conflicts, and questions over sacred matters within oneself, with others, and with God."</p>`,
          ],
          title: "Bill's spiritual struggle?",
          videos: [],
          audio: [],
        },
        20: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>Based on the definition of spiritual struggle provided here, do you think that Bill is experiencing spiritual struggle? Why or why not?</p>",
              order: 0,
              question_type: 2,
              scene_number: "20",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "21", current_scene: "20", text: "Continue" },
          ],
          scene_number: "20",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<p>Someone experiencing divine struggle may say things like:</p><ul>
          <li>I feel like I am being punished by God.</li>
          <li>I feel angry with God for what has happened.</li>
          <li>I feel like God has abandoned me.</li>
          <li>I wonder whether God really loves me.</li>
          <li>I wonder whether the devil has anything to do with this situation.</li>
          <li>I feel I have let God down.</li>
          </ul>`,
            `<p>Someone experiencing interpersonal struggle may say things like:</p><ul>
          <li>I feel my [faith community] has abandoned me.</li>
          <li>I disagree with what my [faith group] wants me to believe.</li>
          <li>I disagree with family or friends about spiritual matters. </li>
          <li>I feel like my family or friends are hypocrites. </li>
          <li>I hope God will have his vengeance on the people who hurt me.</li>
          </ul>`,
            `<p>Someone experiencing intrapsychic struggle may say things like:</p><ul>
          <li>I am having doubts about my faith.</li>
          <li>I am not sure what I really believe anymore. </li>
          <li>I know what's right but I keep doing what's wrong.</li>
          <li>I don't know why I am alive. </li>
          <li>I feel guilty about the way I think, feel, or act.</li>
          </ul>`,
          ],
          text: [
            `<section><h3>Spiritual struggle usually manifests in three different ways:</h3><p>As a struggle between a person and God/the Sacred (Divine struggle), between a person and others (interpersonal struggle), and between a person and oneself (intrapsychic struggle). 
            </p><p>Studies of mental health and spiritual struggle among survivors of trauma show that religious fear and guilt, difficulty forgiving oneself, and feeling alienated from the Divine are associated with more severe PTSD symptoms. Survivors of trauma who experience a loss of faith, like Bill, have poorer mental health and require more support than those whose faith remained intact. Veterans with PTSD are less likely to go to public services at communities of faith. Conversely, those who are able to use their spirituality to find meaning, purpose and comfort have <a href="https://psycnet.apa.org/doi/10.1037/pro0000020" target="_blank">shown higher levels of post-traumatic growth</a>.</p></section>`,
          ],
          title:
            null,
          videos: [],
          audio: [],
        },
        21: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "22", current_scene: "21", text: "Continue" },
          ],
          scene_number: "21",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: null,
          videos: [
            {
              data: "https://www.youtube.com/embed/7UpPPl4c4uk?autoplay=1",
              alt: "After the group",
            },
          ],
          audio: [],
        },
        22: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>How does the news of Bill's death impact you, as his chaplain? How might the news of his death impact others in his community?</p>",
              order: 0,
              question_type: 2,
              scene_number: "22",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "22.0", current_scene: "22", text: "Continue" },
          ],
          scene_number: "22",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>A few weeks later, a member of the group who stays at the same shelter as Bill lets you know that he overdosed and died that weekend. You call the shelter to confirm, knowing that rumors of people dying happen often in the community and that false reports of overdose death can be triggering for community members. The shelter staff confirm what you heard. You make an announcement to the discussion group, letting them know of Bill’s death and inviting them to a memorial service in his honor the following week. You are not sure if anyone will show up, given how fraught Bill’s relationship with the group was.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        "22.0": {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            {
              available_scene: "22.1",
              current_scene: "22.0",
              text: "Continue",
            },
          ],
          scene_number: "22.0",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>How do religious studies scholars define "ritual"?</h3><blockquote>“Ritualization is a way of acting that is designed and orchestrated to distinguish and privilege what is being done in comparison to other, usually more quotidian, activities.” [Catherine M. Bell, Ritual Theory, Ritual Practice (New York: Oxford University Press, 1992), 74.]</blockquote>`,
          ],
          text: [
            `<p>You decide to plan a ritual to honor Bill's life. Memorial services for the homeless community are not standardized. Consider what you are being asked to do. Who is the service for? How do you deal with the complicated dimensions of Bill’s religious history?  Bill was raised Roman Catholic, but renounced his faith after returning from Vietnam. Many members of the group have complicated religious histories, feel distrustful of religion, or feel out of place in a church.</p>`,
          ],
          title: "Honoring Bill",
          videos: [],
          audio: [],
        },
        22.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            {
              available_scene: "22.2",
              current_scene: "22.1",
              text: "Continue",
            },
          ],
          scene_number: "22.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Rituals involve at least three key elements: words, objects, and actions. Rituals use ordinary words, objects, and actions in sacred ways.</p><p>For example: In a Christian baptism the words are “I baptize you in the name of the Father, Son, and the Holy Spirit.” The object is water and the action is sprinkling or pouring it over the person being baptized.</p><p>There are generally two contexts for rituals - highly formalized: weddings, funerals, graduation ceremonies, a 9/11 memorial service; and informal: saying grace before a meal, structured groups like Alcholics Anonymous.</p>
            `,
          ],
          title: "The elements of ritual",
          videos: [],
          audio: [],
        },
        22.2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "23", current_scene: "22.2", text: "Continue" },
          ],
          scene_number: "22.3",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<ul>
            <li>Honor someone’s memory</li>
            <li>Uphold human dignity</li>
            <li>Create and/or sustain community bonds</li>
            <li>Facilitate spiritual and emotional healing</li>
            </ul>
            <p>Chaplains must decide based on the people and community they are serving, as well as their own religious commitments and boundaries, how best to offer meaning making through ritual. 
            They may lead a formal ritual that has already been developed for specific circumstances and people, such as a Jewish baby naming ritual or a military funeral for veterans. They may also bring in religious or secular leaders with the authority to lead a ritual they do not feel authorized or equipped to lead, such as inviting a Catholic priest to perform a Catholic funeral.</p>
            <p>In other circumstances, chaplains may decide to create a custom-made ritual for people who do not belong to religious communities or for a situation that is not accounted for by a prescribed ritual, like a ritual for someone who has recovered from surgery.</p>
            `,
          ],
          title: "Chaplains develop rituals to:",
          videos: [],
          audio: [],
        },
        23: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 9,
          navigation: [
            { available_scene: "24", current_scene: "23", text: "Continue" },
          ],
          scene_number: "23",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>It is now your task to plan Bill's memorial service. Given what you know about Bill, make decisions about the type of service you will plan. There are no wrong answers. Consider how you can best recognize Bill's life while also building a service that will be meaningful the attendees.</p>`,
          ],
          title: null,
          videos: [],
          audio: [
            `https://d38v7trvdc57zc.cloudfront.net/meaning-making/bensound-sadday.mp3`,
          ],
        },
        24: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "25", current_scene: "24", text: "Continue" },
          ],
          scene_number: "24",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Going through the process of designing a ritual for Bill helped you figure out how to honor his life. You feel confident in your plan. However, you still need to consider the context of the service and get it organized.</p>`,
            `<p>Depending on which type of service you chose, you may find this <a href="https://docs.google.com/document/d/1bkDPuKAiGze9O4nk9fgxd5WTuUWduGto4ajj6hx7D20/edit?usp=sharing" target="_blank">memorial service template</a> useful as you plan what you will say.</p>`,
          ],
          title: `Next steps`,
          videos: [],
          audio: [],
        },
        25: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>How did thinking about the circumstances of Bill's life and death shape the decisions you made in planning his memorial?</p>",
              order: 0,
              question_type: 2,
              scene_number: "25",
              sidebar: false,
            },
          ],
          images: [
            {
              alt: "Flyer for Homeless Persons Interfaith Memorial Service",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/meaning-making/homeless+memorial.png",
              order: 0,
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "25.1", current_scene: "25", text: "Continue" },
          ],
          scene_number: "25",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Bill's service was on the following Saturday. Using the words, objects, and actions that you planned, the service recognized Bill's life and tended to those who were impacted by it: his group and shelter mates who will miss him, or for whom his death is a reminder of their own mortality.</p><p> Often times, death can bring reminders of other losses, so community members may be more upset than you - or they - expect. It can be important to remind people, especially in the Sunday morning group with whom you regularly meet, that however people are feeling is normal.</p><blockquote>You might say, "You may be feeling sad, or angry, or regretful, or nothing at all. Any loss, regardless of how close we were to the person, can bring up all the other losses we've experienced in our lives. So, be gentle with yourself and with one another, and know that I am available if you want to talk about any grief you're feeling." </blockquote>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        25.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "26", current_scene: "25.1", text: "Continue" },
          ],
          scene_number: "25.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Working with populations on the streets requires paying attention to the physical environment and listening and looking for cues about how members of that population relate to a home without walls.</p><p>You have considered how you, as a chaplain, might work with spiritual struggles, trauma and moral injuries. The struggles are not simply in the past but involve obstructions to reintegrating back into civilian structures and institutions. You have also considered some elements and steps to creating meaningful rituals.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        26: {
          checkpoint: false,
          last: true,
          checkpoints: [],
          images: [],
          layoutNumber: 6,
          navigation: [],
          scene_number: "26",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You finished this lesson! Take a moment to download your responses to the questions you answered along the way. You can print them for future review or to show to your instructor if you are using this lesson in a class.</p>`,
            `<div style="background-color: white;
              padding: 10px;
              border-radius: 10px;
              margin-top: 10vh;"><h3 style="color: black">Want to learn more?</h3><p>Here are some additional resources: </p>
              <ul>
              <li><a href="https://static1.squarespace.com/static/53f25c8fe4b0014b3798ea58/t/5a394145e2c48325eff88c5a/1513701726612/FMN-Guide-for-Movement-Chaplains.pdf" target="_blank">A Guide for Movement Chaplains</a></li>
              <li><a href="https://youtu.be/_s1pf-vdj8o" target="_blank">Faith Communities, Veterans, and Mental Health (video)</a></li> 
              </ul></div>`,
          ],
          title: `Lesson complete`,
          videos: [],
          audio: [],
        },
      };
      return data;
    } else if (action.payload === 1) {
      let data = {
        1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "A prison interior",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/emiliano-bar-PaKHbtTDqt0-unsplash.jpg",
              order: 0,
            },
          ],
          layoutNumber: 3,
          navigation: [
            { available_scene: "2", current_scene: "1", text: "Continue" },
          ],
          scene_number: "1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: "Navigating Policy, Faith, and Identity",
          videos: [],
          audio: [],
        },
        2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "3", current_scene: "2", text: "Continue" },
          ],
          scene_number: "2",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>One of the challenges of being a professional chaplain is maintaining one’s own spritual and religious authority and identity while serving the wider spiritual and pastoral care needs of persons from other faiths and those with no faith at all. </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        3: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              order: 0,
              alt: "People in prayer",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/meaning-making/pedro-dias-IkqhfoJjwSI-unsplash.jpg",
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "4", current_scene: "3", text: "Continue" },
          ],
          scene_number: "3",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>When many chaplains pursued advanced theological education, they primarily studied their own particular religious tradition.</p><p>Chaplains studied theology, sacred scriptures, spiritual disciplines, pastoral care, and how to oversee communities of faith. They interned and served as religious leaders in parishes, synagogues, mosques, temples, other community places of worship, or non-profits.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        4: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "5", current_scene: "4", text: "Continue" },
          ],
          scene_number: "4",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Chaplains value their distinct religious tenets, worship, and spiritual practices.  They  find deep spiritual and theological meaning within their religious communities. They are commissioned, licensed, ordained, and/or appointed to advance their specific religious traditions in everything they do. Chaplains may feel that this work is their life calling, their mission, and ultimate purpose.</p><p>Leading worship, sacred scripture studies, small group ministries, pastoral visitation, and spiritual counseling are deeply important to deepening their faith and serving others. Faith specific community leadership is their primary and default ministry model and often a prerequisite to serve in institutional professional chaplaincy positions.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        5: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              order: 0,
              alt: "Group religious gathering",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/policy/adrianna-geo-W5oBN7u4yfw-unsplash.jpg",
            },
            {
              order: 1,
              alt: "Father and child in prayer",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/policy/hasan-almasi-kPWfbe65lb4-unsplash.jpg",
            },
            {
              order: 2,
              alt: "Woman sitting with a religious text in her lap",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/policy/olivia-snow-CPPFtCHY6mo-unsplash.jpg",
            },
          ],
          layoutNumber: 7,
          navigation: [
            { available_scene: "6", current_scene: "5", text: "Continue" },
          ],
          scene_number: "5",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Finding ways to stay grounded in one’s particular religious training and credentialing is critical to one’s spiritual identity as a Rabbi, Imam, Pastor, Priest, or Minister. Prioritizing continual spiritual renewal activities such as regular devotional practices, accountable groups, retreats, and meeting with spiritual directors becomes critical to maintaining ongoing healthy spiritual leadership.</p><p>Wellness and self-care enable chaplains to be the spiritual leaders who inspire and guide others in healthy spiritual devotion. </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        6: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "7", current_scene: "6", text: "Continue" },
          ],
          scene_number: "6",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Sometimes a conflict may emerge between how chaplains nurture their own faith community while serving in an interfaith chaplaincy setting. Their values, morals, ethics, theology, and priorities may be stretched to create time and space for religious traditions that hold different foundational ideas and may be in direct conflict to their religious beliefs.</p><p>In this lesson, you will examine this spiritual, personal, and professional tension first hand, experiencing the real turmoil that emerges when one’s personal and professional identity rubs up against the demands of serving effectively in a pluralistic and secular ministry context. You will be asked to imagine how you might reconcile an established institutional expectation that conflicts with your own faith and religious identity.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },

        7: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt:
                "Entrance to the Federal Correctional Institution, Three Rivers, TX",
              order: 0,
              image:
                "https://d38v7trvdc57zc.cloudfront.net/policy/Federal_Prison_(855127147).jpg",
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "8", current_scene: "7", text: "Continue" },
          ],
          scene_number: "7",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Balancing this tension is made more difficult by the context you face in this lesson: as a chaplain working in a federal prison. Prisons are one of the three institutions which are required by law to employ chaplains, along with the military and the Veteran's Administration. </p><p>Religion can be a hotly contested part of prison life, and you as the chaplain are responsible for managing religious freedoms or restrictions.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        8: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "9", current_scene: "8", text: "Continue" },
          ],
          scene_number: "8",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>By the end of this lesson, you will be able to:</p>
          <ul>
          <li>identify when your personal theology is in conflict with institutional theology or institutional needs
          </li>
          <li>recognize how policies can result in the restriction of rights - of chaplains and those they serve</li>
          </ul>`,
          ],
          title: "What you will learn",
          videos: [],
          audio: [],
        },
        9: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>Take a moment to reflect upon the statistics from the Pew Research Center. How do you think the predominantly, white, male, and Christian prison chaplain staff might impact spiritual care in prisons? </p>",
              order: 0,
              question_type: 2,
              scene_number: "20",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "9.1", current_scene: "9", text: "Continue" },
          ],
          scene_number: "9",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<h3>What do we know about prison chaplains?</h3><p> In 2012, the Pew Research Center conducted a <a href="https://www.pewforum.org/2012/03/22/prison-chaplains-profile/" target="_blank">study of 730 state prison chaplains across 50 states</a>. They found that majority of chaplains serving in prisons identify as white, male, Christian, and religiously, as well as politically, conservative. While in this case, we're looking at chaplains who work in the federal prison system, the data from this study can help us to get a picture of what types of people might be drawn to work as chaplains in the federal prison system.</p>
          <p>The Pew Center report notes that they asked federal prison chaplains to participate in the study, but they were not allowed to do so.</p>`,
          ],
          title: null,
          videos: [
            {
              data: "https://www.youtube-nocookie.com/embed/IEzYsiAb4Iw",
              alt:
                "The majority of state prison chaplains identify as white, male, and Christian",
            },
          ],
          audio: [],
        },
        9.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "You, a prison chaplain",
              order: 0,
              image: "https://d38v7trvdc57zc.cloudfront.net/policy/you.png",
            },
          ],
          layoutNumber: 1,
          navigation: [
            { available_scene: "10", current_scene: "9.1", text: "Continue" },
          ],
          scene_number: "9.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Let's jump into the story. Imagine yourself as the main character in this scenario: a typical chaplain working in a federal prison. You'll learn more about your specific background on the next page.</p><p>Based on what you know about working in as a chaplain in prison, how would this character respond to the dilemma in this story?</p>`,
          ],
          title: "The situation",
          videos: [{}],
          audio: [],
        },
        10: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "11", current_scene: "10", text: "Continue" },
          ],
          scene_number: "10",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<p><a href="https://www.npr.org/2019/07/25/745226402/muslims-over-represented-in-state-prisons-report-finds" target="_blank">According to Tariq Aquil</a>, a retired Muslim chaplain for the California state prison system, the growing number of Muslim incarcerated people does not necessarily correlate to any possible growth in arrests of Muslims. Instead, "About 90 percent of incarcerated Muslims in the United States become Muslims during their incarceration."`,
          ],
          text: [
            `<p>You are an ordained clergy person who entered full time prison chaplaincy from serving in community faith leadership.  Previously you were an evangelical Christian pastor in the community. You work in a men's federal medium security prison in a rural area of your state. You were drawn to this work in order to serve a population that you care deeply about: incarcerated people. However, this is difficult work.</p><p>Now you are tasked with ensuring the worship and religious study to the inmates from your particular faith tradition, while also facilitating the constitutionally protected religious practice of more than twenty congregant faith traditions and countless individual religious practitioners. Your prison, like many across the country, has a growing Muslim population, but no staff Muslim chaplains.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        11: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "12", current_scene: "11", text: "Continue" },
          ],
          scene_number: "11",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: null,
          videos: [
            {
              data: "https://www.youtube-nocookie.com/embed/sp7nnXkTPP0",
              alt: "What does a prison chaplain do?",
            },
          ],
          audio: [],
        },
        12: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "13", current_scene: "12", text: "Continue" },
          ],
          scene_number: "12",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You are also responsible for managing the prison chapel scheduling. This is an interfaith space which is required to be open for all groups. Your prison also has an outdoor worship space. Your office, the offices of your fellow staff chaplains, and all of the supplies you use in administering religious life in the prison, are located just outside of the chapel.</p>
          <p>Beyond just being a meeting and worship space, the chapel is the only place where inmates are allowed to wear approved cermonial clothing. The <a href="https://www.bop.gov/policy/progstat/5360_009.pdf" target="_blank">Religious Beliefs and Practices program statement (revised in 2015)</a> outlines these affordances.</p>
          <section>
            <p> <strong>4) Ceremonial Clothing</strong> At the Warden's discretion, the following articles of personal religious clothing may be worn for services in the Chapel, but not on the compound, housing units or visiting room:</p>
            <table>
            <thead>
            <tr>
            <td>Group</td><td>Item</td><td>Explanation</td>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td>Jewish</td><td>kittel</td><td>a white prayer robe worn during some holiday services.</td>
            </tr>
            <tr><td>Muslim</td><td>kurta shirt</td><td>a knee-length shirt worn during the weekly Jumah service</td>
            </tr>
            <tr>
            <td>Native American</td><td>ribbon shirt</td><td>a multicolor shirt work during the Pow Wow</td>
            </tr>
            <tr>
            <td>Wicca</td><td>tabbred</td><td>a hoodless poncho or cape, earth brown color, worn during services</td>
            </tr>
            </tbody>
            </table>
            
          </section>
          <p>Other cermonial items, such as wine, can only be used in the Chapel. Wine is considered contraband outside of an approved ceremonial gathering. As such, if ceremonial items and/or clothing are required for worship, access to the Chapel is crucial. </p>
          </p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        13: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              order: 0,
              alt: "At your desk",
              image:
                "https://d38v7trvdc57zc.cloudfront.net/policy/Meet+Mark-480p-210118.gif",
            },
          ],
          layoutNumber: 2,
          navigation: [
            { available_scene: "14", current_scene: "13", text: "Continue" },
          ],
          scene_number: "13",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You’ve received a number of requests for use of the chapel space in the coming month. The stack of proposals is sitting on your desk when you arrived for your shift this morning. It’s filling you with dread to look at it as you know that there is one day with major scheduling conflicts. Today you must make final decisions about these services.</p><p> Your colleague Mark, another evangelical Christian chaplain in his mid-50s, is working with you this morning and you know that he will have to weigh in. While you share Mark's faith and often lean on him for spiritual guidance and accountability, you are also dreading that conversation as Mark is openly mistrustful of many of the Muslim prisoners.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        14: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "15", current_scene: "14", text: "Continue" },
          ],
          scene_number: "14",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You take a look at the stack of papers on your desk. There are three requests for this coming Friday: one for a regular Jumah service, which occurs every Friday at noon for practicing Muslims; one for a Christian Good Friday service; and one for a Passover seder for Jewish prisoners.</p><p>Your job as a prison chaplain is to accommodate and facilitate a wide range religious practices for inmates. Each faith group should have time and space in chapel areas for worship and religious study, access to religious items and materials from their tradition, access to their Minister of Record (their official clergy person who can visit with them in the visiting room), certified religious diets upon request, and access to faith specific volunteers. Federal law mandates that you provide equitable access to religious space and freedom of practice. This can pose a challenge, both logistically and spiritually, for chaplains working in the prison system.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        15: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "16", current_scene: "15", text: "Continue" },
          ],
          scene_number: "15",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p> You are most familiar with the importance of the Christian service, as this is your own faith background. Furthermore, as an evangelical Christian, you believe that spreading Christianity is your duty to God. You know that in order to serve in an interfaith setting, you must balance your own faith beliefs of evangelizing Christianity with granting access to worship for non-Christian prisoners, but this often causes inner spiritual turmoil. You sometimes feel yourself going against your religious mandates in order to serve in this role.</p>

          <p>Because you work a long shift, if you end up holding a service for a group other than your own on that day, you will miss out on your own religious practice. But so will everyone else, potentially. In the past, your other evangelical Christian colleagues have prioritized Christian services over other groups' needs. You feel compelled to both uphold your job duties and your faith mandates.</p>
          
          <p>You hate being in this position, but you know this is an integral part of your job.</p> `,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        16: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "17", current_scene: "16", text: "Continue" },
          ],
          scene_number: "16",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>When you worked as a pastor, you did not have to regularly make so many decisions that grant access to worship. Your purpose was to serve your congregation, welcoming in anyone who was interested. Serving in a prison is important work, but (and) it is difficult to feel responsible for the spiritual nourishment of incarcerated people while also participating in restricting their freedoms.</p><p>On paper, you are supposed to provide equitable access to worship for all prisoners, however in practice, this is not always possible. In some cases, the policy is interpreted to deny prisoners' access to religious practice.</p>
       `,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        17: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "18", current_scene: "17", text: "Continue" },
          ],
          scene_number: "17",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `
            <div>
            <p>The Federal Bureau of Prisons' <a href="https://www.bop.gov/policy/progstat/5360_009.pdf" target="_blank">"Religious Beliefs and Practices Program Statement"</a> dictates the policies that shape your work.</p>
            <p><strong>3. PROGRAM OBJECTIVES.</strong> The expected results of this program are:
            <ol type="a">
             <li>Religious accommodations will be made for all religions
            authorized to meet in Bureau of Prisons facilities.</li>
          <li>The religious rights of inmates of all faiths will be
            protected within the parameters of the security and orderly
            running of the institution.</li>
            <li>Religious resources will be equitably distributed for the
            benefit of all inmates.</li>
            <li>Pastoral care will be available to inmates and staff.</li>
            <li>Expertise on matters of religion in the correctional
            environment will be available for staff.</li>
            </ol>
            <p>However, other mandates within this document allow prison staff to restrict access to religious resources and accommodations in order to maintain security, broadly construed, in the prison: <blockquote>"If upon review, the Warden determines that a religious practice jeopardizes institution safety, security and good order, the practice may be temporarily restricted."</blockquote> In some cases, the mandate to preserve safety rely upon racist, xenophobic, and Islamophobic sentiments, enacted by Wardens and chaplains. For instance, the document states: <blockquote>"Sermons, original oratory, teachings and admonitions must be delivered in English."</blockquote></p>
            </div>
       `,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        18: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "A person reading the Quran",
              order: 86,
              image:
                "https://d38v7trvdc57zc.cloudfront.net/policy/quran-4095475_1280.jpg",
            },
          ],
          layoutNumber: 7,
          navigation: [
            { available_scene: "19", current_scene: "18", text: "Continue" },
          ],
          scene_number: "18",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [
            `<h3>Further Reading</h3><p>Read <a href="https://muslimadvocates.org/wp-content/uploads/2019/07/FULFILLING-THE-PROMISE-OF-FREE-EXERCISE-FOR-ALL-Muslim-Prisoner-Accommodation-In-State-Prisons-for-distribution-7_23.pdf" target="_blank"> the full report</a> or <a href="https://www.npr.org/2019/07/25/745226402/muslims-over-represented-in-state-prisons-report-finds" target="_blank">listen to the NPR coverage</a>. </p>`,
          ],
          text: [
            `<p>A 2019 report on Muslim prisoner accommodations in state prisons found "that many state prisons are arbitrarily and illegally preventing incarcerated Muslims from practicing their faith."</p><p>Yusuf Saei, author of this report, explains: "Another important finding is that incarcerated Muslims are asking for very basic things: religiously compliant food, books, prayer mats, but they're not receiving them in many states."</p><p>While on paper, all prisoners should have equal access to religious resources, in practice, this doesn't always occur.</p>`,
          ],
          title: "Institutionalized Islamophobia",
          videos: [],
          audio: [
            "https://d38v7trvdc57zc.cloudfront.net/policy/20190725_me_muslims_are_over-represented_in_state_prisons_report_says.mp3",
          ],
        },
        19: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>What strategies might you use to prepare yourself to navigate this work environment? How could you draw upon your faith and training to guide you?</p>",
              order: 0,
              question_type: 2,
              scene_number: "20",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "20", current_scene: "19", text: "Continue" },
          ],
          scene_number: "19",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You are enmeshed in this context as an evangelical Christian chaplain. You want to correct these biases against Muslim prisoners, but you are often facing an uphill battle against your peers and supervisors.</p><p>You are also restricted by other regulations set by the federal policy. For instance, all worship services need to be supervised religious staff, even if they are run by an approved volunteer, such as a Rabbi or Imam from the community.</p><p>Services need to be scheduled around prisoner work hours, meals, and head counts. If there is an emergency - such as an institutional lock down, hunger strike, or extreme weather - the Warden may shut down chapel programming entirely.</p><p> Some days it feels impossible to balance the logistical mandates of the policy with the work of serving prisoners and prison staff and remaining true tor your faith.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        20: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 9,
          navigation: [
            { available_scene: "20.1", current_scene: "20", text: "Continue" },
          ],
          scene_number: "20",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<section><h3>You glance back down at the stack of requests for chapel space and begin to process this decision.</h3></section>
            <div>
            <aside>
            <h3>Jumah prayer request</h3>
            <p><em>Date and time:</em> Fridays, 12pm - 1pm (recurring)</p>
            <p><em>Requirements:</em></p>
            <ul>
            <li>An open space, with carpeting or a clean surface.</li>
            <li>An area for shoes/slippers to be removed and stored.</li>
            <li>Inmates will use the washrooms before arriving at the chapel to complete the ritual washing (wudu) and be ready for prayer.</li>
            <li>An imam or volunteer chaplain should lead the service.</li>
            <li>The prayer leader should use a chair at the head of the congregation to sit and stand while delivering the sermon. The prayer leader also needs a prayer rug, to be positioned in front of the first line of followers; a podium next to the chair for sermon notes; and a copy of the Quran.</li>
            </ul>
            <p><em>Service details:</em> Inmates may spend about 10-15 minutes in private prayer before the sermon begins. The sermon may last 15-30 minutes. After the collective prayer, inmates will complete some personal prayers, retrieve their shoes, and then exit the area.</p>
            <img src="https://d38v7trvdc57zc.cloudfront.net/policy/Interior_jummah_taltoli_jama_masjeed.jpg" width="80%" alt="a group of men gathered for a jumah prayer"/>
            </aside>
            <aside>
            <h3>Passover seder request</h3>
            <p><em>Date and time:</em> Friday, after sundown</p>
            <p><em>Requirements:</em></p>
            <ul>
            <li>A space with tables and chairs for sharing food.</li>
            <li>A seder plate with foods that symbolize the story of Exodus: hard-boiled eggs (<em>beitza</em>), roasted shank bones from a lamb or chicken (<em>zeroa</em>), spring vegetables (<em>karpas</em>), a mixture of apples, wine, and nuts (<em>charoset</em>), and bitter herbs, such as horseradish (<em>maror</em>).</li>
            <li>A small dish of salt water to dip greens into for each participant.</li>
            <li>A plate with matzah.</li>
            <li>Wine and kiddush cups - each participant should have four glasses.</li>
            <li>Copies of the Haggadah for each participant.</li>
            <li>Basins of water and towels for hand washing rituals.</li>
            <li>A pillow for each participant.</li>
            <li>Candles.</li>
            </ul>
            <p><em>Service details:</em> A Rabbi, chaplain, or volunteer will lead the inmates in a Passover seder: reading from the Haggadah, drinking four cups of wine, telling stories, eating symbolic foods, and singing. Passover, like all Jewish holidays, begins at sundown. The seder must be held after nightfall.</p>
            <img src="https://d38v7trvdc57zc.cloudfront.net/policy/Passover1.jpg" width="80%" alt="a Passover seder meal inside a prison"/>
            </aside>
            <aside>
            <h3>Good Friday service</h3>
            <p><em>Date and time:</em> Friday, 12pm - 1pm</p>
            <p><em>Requirements:</em></p>
            <ul>
            <li>Seating for inmates, with hymnals for following along with songs during service.</li>
            <li>A music source for playing music: either recorded or live.</li>
            <li>A chaplain or volunteer pastor should perform the service.</li>
            <li>Wine and Eucharist for communion.</p>
            </ul>
            <p><em>Service details:</em> The chaplain or pastor will deliver a sermon, leading inmates in prayer for 30-45 minutes. Inmates will be invited to take communion, consuming wine and Eucharist.</p>
            <img src="https://d38v7trvdc57zc.cloudfront.net/policy/IMG_4091-768x512.jpg" width="80%" alt="a Christian service in a prison chapel"/>
            </aside>
            </div>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        20.1: {
          checkpoint: false,
          last: false,
          checkpoints: [
          ],
          images: [
            {
              alt: "",
              order: 0,
              image:
                "https://d38v7trvdc57zc.cloudfront.net/policy/how+did+you+do--480p-210118.gif",
            },
          ],
          layoutNumber: 2,
          navigation: [
            { available_scene: "20.2", current_scene: "20.1", text: "Continue" },
          ],
          scene_number: "20.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<div><p>You encountered a difficult logistical, spiritual, and interpersonal decision while working to enact a policy at your workplace. Your own inner turmoil about staying true to your faith as an evangelical Christian while serving in an interfaith setting was heightened when you faced pressure from your other evangelical Christian colleagues to perform the Christian Good Friday service and deny the other requests. What resolution did you reach? How did you feel walking through this process?</p><p>Whichever path you chose, you likely had to grapple with consequences:</p> <ul><li>potential conflict with your colleague</li><li>failure to fulfill your mandate to provide equal access to space</li><li>failure to uphold your faith beliefs</li><li>stress from managing logistics</li></ul>
            </div>`,
          ],
          title: "How did you do?",
          videos: [],
          audio: [],
        },
        20.2: {
          checkpoint: true,
          last: false,
          checkpoints: [
            {
              alt: null,
              answer: false,
              content_type: 5,
              data:
                "<p>Take a moment to imagine how your religious understanding, relationships, and attitudes might change by accommodating multiple faith groups. What would be most challenging for you working in such a setting?</p>",
              order: 0,
              question_type: 2,
              scene_number: "21",
              sidebar: false,
            },
          ],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "21", current_scene: "20.2", text: "Continue" },
          ],
          scene_number: "20.2",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [`<h3>A chaplain's perspective</h3><p>What's it really like working as a prison chaplain, negotiating these multiple tensions?</p>`],
          title: null,
          videos: [
            {
              data: "https://www.youtube-nocookie.com/embed/9CHyIkitXkw",
              alt:
                "Taymullah Abdur-Rahman",
            },
            {
              data: "https://www.youtube-nocookie.com/embed/LyHvUxLmoAM",
              alt:
                "Taylor Winfield",
            },
          ],
          audio: [],
        },
        21: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "22", current_scene: "21", text: "Continue" },
          ],
          scene_number: "21",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Most chaplains serve in interfaith environments and need to learn how to balance their own faith with the needs of those that they serve. It is your duty to serve inmates of other faiths, while also fostering and strengthening your own faith leadership.</p><p>Lean into your religious practice and wisdom from your spiritual mentors through:</p>
            <ul><li>sacred scripture study</li><li>worship</li><li>accountability groups</li><li>and other faith specific disciplines</li></ul><p>Deepening your own faith and drawing on wisdom from trusted mentors and colleagues will help you to ground your practice in your faith traditions. At the same time, it is crucial to seek support from others who work in interfaith settings to strengthen your ability to stay true to your faith while also serving those who do not share your religion.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        22: {
          checkpoint: false,
          last: true,
          checkpoints: [],
          images: [],
          layoutNumber: 6,
          navigation: [
            { available_scene: "23", current_scene: "22", text: "Continue" },
          ],
          scene_number: "22",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            ` <p>You finished this lesson! Take a moment to download your responses to the questions you answered along the way. You can print them for future review or to show to your instructor if you are using this lesson in a class.</p>`,
            `<div style="background-color: white;
              padding: 10px;
              border-radius: 10px;
              margin-top: 10vh;"><h3 style="color: black">Want to learn more?</h3><p>Here are some additional resources: </p>
              <ul>
              <li><em>Embracing Interfaith Cooperation</em> by Eboo Patel with Tim Scorer</li>
              <li><em>Clergy Self-Care: Finding a Balance for Effective Ministry</em> by Roy M. Oswald</li>
              </ul></div>`,
          ],
          title: "Lesson complete",
          videos: [],
          audio: [],
        },
      };
      return data;
    } else {
      return null;
    }
  } else {
    return state;
  }
};
export default lessonData;
